/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ATL-Service-API
 * OpenAPI spec version: 1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import { customFetch } from './fetch-mutator';
export interface AcceptUserDTO {
  userId: string;
  isMailAgreement: boolean;
}

export interface AuthResponseDTOObject {
  /** @minLength 1 */
  message: string;
  payload?: unknown;
}

export interface OfferDTO {
  wagonTariff?: number;
  indexNumber?: number;
}

export interface OfferResponseDTO {
  orderId: string;
  userId: string;
  offers: OfferDTO[];
  countWagonsOwner?: number;
}

export interface TradeResponseDTOObject {
  /** @minLength 1 */
  message: string;
  payload?: unknown;
}

export interface ParticipantAgreedWagonsSaveRequestDTO {
  orderId: string;
  participants: ParticipantAgreedWagonsUpdateDTO[];
}

export interface ParticipantAgreedWagonsUpdateDTO {
  id: string;
  numberAgreedWagons?: number;
}

export interface MyOffersSaveRequestDTO {
  orderId: string;
  userId: string;
  offers: OfferDTO[];
}

export interface OrderCancelRequestDTO {
  orderId?: string;
  comment?: string;
}

export interface AllOffersSaveRequestDTO {
  orderId: string;
  offers: OfferDTO[];
}

export interface UserEditDataDTO {
  id: string;
  /**
   * @minLength 0
   * @maxLength 150
   */
  username?: string;
  /**
   * @minLength 6
   * @maxLength 100
   */
  email?: string;
  /**
   * @minLength 0
   * @maxLength 50
   */
  contactNumber?: string;
  /**
   * @minLength 8
   * @maxLength 64
   */
  password?: string;
  /**
   * @minLength 0
   * @maxLength 12
   */
  inn: string;
  /**
   * @minLength 0
   * @maxLength 150
   */
  name?: string;
  /**
   * @minLength 0
   * @maxLength 9
   */
  kpp?: string;
  /**
   * @minLength 0
   * @maxLength 13
   */
  ogrn?: string;
  /**
   * @minLength 0
   * @maxLength 50
   */
  companyContactNumber?: string;
  /**
   * @minLength 0
   * @maxLength 250
   */
  addressLegal?: string;
  /**
   * @minLength 0
   * @maxLength 250
   */
  addressActual?: string;
  /**
   * @minLength 6
   * @maxLength 100
   */
  companyEmail?: string;
}

export interface SetUserBlockingDTO {
  userId: string;
  isBlocking: boolean;
}

export interface SetUserPermissionDTO {
  id: string;
  createApplication: boolean;
  extensionOfAuction: boolean;
  cancelApplication: boolean;
  viewingWinners: boolean;
}

export interface OrderContinueRebiddingApproveDTO {
  id: string;
  approve: boolean;
  comment?: string;
}

export interface AcceptOrderDTO {
  id?: string;
  isAccept?: boolean;
  comment?: string;
}

export interface AcceptOrderCancelDTO {
  id?: string;
  isAccept?: boolean;
}

export interface RefreshRequest {
  /** @minLength 1 */
  refreshToken: string;
}

export interface AuthResponseDTOAuthUserDTO {
  /** @minLength 1 */
  message: string;
  payload?: AuthUserDTO;
}

export type AuthUserDTORole = typeof AuthUserDTORole[keyof typeof AuthUserDTORole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AuthUserDTORole = {
  ADMIN: 'ADMIN',
  CARGO_OWNER: 'CARGO_OWNER',
  WAGON_OWNER: 'WAGON_OWNER',
} as const;

export interface AuthUserDTO {
  id: string;
  role: AuthUserDTORole;
  /** @minLength 1 */
  accessToken: string;
  /** @minLength 1 */
  refreshToken: string;
}

export interface AuthRequest {
  /** @minLength 1 */
  login: string;
  /** @minLength 1 */
  password: string;
  remember: boolean;
}

export interface OrderContinueRebiddingRequestDTO {
  orderId: string;
  userId: string;
  dayCount: number;
}

export interface DraftOrderDto {
  id?: string;
  userId: string;
  orderNumber: string;
  loadingStation?: string;
  loadingRoad?: string;
  cargoId?: string;
  cargoWeight?: number;
  totalWagons?: number;
  unloadingDirection?: UnloadingDirectionDTO[];
  modelId?: string;
  wagonType?: string;
  cargoComments?: string;
  standartTimeLoading?: number;
  standartTimeUnloading?: number;
  penalty?: number;
  moratorium?: boolean;
  deadlineAt?: string;
  deadlineTo?: string;
  decade?: boolean;
  decadeFirst?: number;
  decadeSecond?: number;
  decadeThird?: number;
  decadeComments?: string;
  tradeBegin?: string;
  tradeEnd?: string;
  collectionBegin?: string;
  collectionEnd?: string;
  retrading?: boolean;
  retradingBegin?: string;
  retradingEnd?: string;
  resultsDate?: string;
  liftingCapacity?: number;
  bodySize?: number;
}

export type UnloadingDirectionDTOTariffRoad = typeof UnloadingDirectionDTOTariffRoad[keyof typeof UnloadingDirectionDTOTariffRoad];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UnloadingDirectionDTOTariffRoad = {
  WITH_20_VAT: 'WITH_20_VAT',
  WITH_0_VAT: 'WITH_0_VAT',
  WITH_OUT_VAT: 'WITH_OUT_VAT',
  COEFFICIENT: 'COEFFICIENT',
} as const;

export type UnloadingDirectionDTOTariffStation = typeof UnloadingDirectionDTOTariffStation[keyof typeof UnloadingDirectionDTOTariffStation];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UnloadingDirectionDTOTariffStation = {
  WITH_20_VAT: 'WITH_20_VAT',
  WITH_0_VAT: 'WITH_0_VAT',
  WITH_OUT_VAT: 'WITH_OUT_VAT',
  COEFFICIENT: 'COEFFICIENT',
} as const;

export interface UnloadingDirectionDTO {
  /** @minLength 1 */
  unloadingRoad: string;
  tariffRoad?: UnloadingDirectionDTOTariffRoad;
  unloadingStation?: string;
  countWagons?: number;
  tariffStation?: UnloadingDirectionDTOTariffStation;
  indexNumber?: number;
}

export interface OrderCreateDto {
  id?: string;
  userId: string;
  orderNumber?: string;
  /** @minLength 1 */
  loadingStation: string;
  /** @minLength 1 */
  loadingRoad: string;
  /** @minLength 1 */
  cargoId: string;
  cargoWeight: number;
  totalWagons: number;
  unloadingDirection?: UnloadingDirectionDTO[];
  modelId?: string;
  /** @minLength 1 */
  wagonType: string;
  cargoComments?: string;
  /** @maximum 9999 */
  standartTimeLoading?: number;
  /** @maximum 9999 */
  standartTimeUnloading?: number;
  penalty?: number;
  moratorium?: boolean;
  deadlineAt: string;
  deadlineTo: string;
  decade?: boolean;
  /** @maximum 9999 */
  decadeFirst?: number;
  /** @maximum 9999 */
  decadeSecond?: number;
  /** @maximum 9999 */
  decadeThird?: number;
  decadeComments?: string;
  tradeBegin?: string;
  tradeEnd?: string;
  collectionBegin?: string;
  collectionEnd?: string;
  retrading?: boolean;
  retradingBegin?: string;
  retradingEnd?: string;
  resultsDate?: string;
  liftingCapacity?: number;
  bodySize?: number;
}

export type CreateUserDTORole = typeof CreateUserDTORole[keyof typeof CreateUserDTORole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CreateUserDTORole = {
  ADMIN: 'ADMIN',
  CARGO_OWNER: 'CARGO_OWNER',
  WAGON_OWNER: 'WAGON_OWNER',
} as const;

export interface CreateUserDTO {
  /** @minLength 1 */
  username: string;
  /**
   * @minLength 0
   * @maxLength 30
   */
  login: string;
  /**
   * @minLength 6
   * @maxLength 100
   */
  email?: string;
  /**
   * @minLength 6
   * @maxLength 100
   */
  companyEmail?: string;
  /**
   * @minLength 8
   * @maxLength 2147483647
   */
  passwordHash: string;
  role?: CreateUserDTORole;
  /**
   * @minLength 0
   * @maxLength 150
   */
  companyName?: string;
  /**
   * @minLength 0
   * @maxLength 12
   */
  inn: string;
  /**
   * @minLength 0
   * @maxLength 9
   */
  kpp: string;
  /**
   * @minLength 0
   * @maxLength 13
   */
  ogrn: string;
  /**
   * @minLength 0
   * @maxLength 50
   */
  contactNumber: string;
  /**
   * @minLength 0
   * @maxLength 50
   */
  companyContactNumber: string;
  /**
   * @minLength 0
   * @maxLength 250
   */
  addressLegal: string;
  /**
   * @minLength 0
   * @maxLength 250
   */
  addressActual: string;
}

export interface PasswordChangeDTO {
  id: string;
  /** @minLength 1 */
  passwordNewOne: string;
  /** @minLength 1 */
  passwordNewTwo: string;
  passwordOld?: string;
}

export interface TradeTmpDto {
  id?: number;
  orderName?: string;
}

export interface NotificationTmpDto {
  id?: number;
  message?: string;
}

export interface AuthTmpDto {
  id: number;
  /** @minLength 1 */
  username: string;
}

export type MyParticipationOrderResponseDTOStatus = typeof MyParticipationOrderResponseDTOStatus[keyof typeof MyParticipationOrderResponseDTOStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MyParticipationOrderResponseDTOStatus = {
  DRAFT: 'DRAFT',
  ON_MODERATION: 'ON_MODERATION',
  ON_REVISION: 'ON_REVISION',
  WAITING_TRADE: 'WAITING_TRADE',
  COLLECT_PROPOSAL: 'COLLECT_PROPOSAL',
  REBIDDING: 'REBIDDING',
  SUMMING_UP: 'SUMMING_UP',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
} as const;

export interface MyParticipationOrderResponseDTO {
  id?: string;
  orderNumber?: string;
  tradeBegin?: string;
  tradeEnd?: string;
  status?: MyParticipationOrderResponseDTOStatus;
  participantsCount?: number;
  loadingStation?: string;
  loadingRoad?: string;
  cargoName?: string;
  cargoWeight?: number;
  wagonsType?: string;
  stageBegin?: string;
  endBegin?: string;
  totalWagons?: number;
}

export interface PageableResponseDTOMyParticipationOrderResponseDTO {
  currentPage?: number;
  totalPage?: number;
  totalItems?: number;
  items?: MyParticipationOrderResponseDTO[];
}

export interface TradeResponseDTOPageableResponseDTOMyParticipationOrderResponseDTO {
  /** @minLength 1 */
  message: string;
  payload?: PageableResponseDTOMyParticipationOrderResponseDTO;
}

export type OrderPageAllTradeSobResponseDTOStatus = typeof OrderPageAllTradeSobResponseDTOStatus[keyof typeof OrderPageAllTradeSobResponseDTOStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderPageAllTradeSobResponseDTOStatus = {
  DRAFT: 'DRAFT',
  ON_MODERATION: 'ON_MODERATION',
  ON_REVISION: 'ON_REVISION',
  WAITING_TRADE: 'WAITING_TRADE',
  COLLECT_PROPOSAL: 'COLLECT_PROPOSAL',
  REBIDDING: 'REBIDDING',
  SUMMING_UP: 'SUMMING_UP',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
} as const;

export interface OrderPageAllTradeSobResponseDTO {
  id?: string;
  orderNumber?: string;
  tradeBegin?: string;
  tradeEnd?: string;
  status?: OrderPageAllTradeSobResponseDTOStatus;
  stageBegin?: string;
  endBegin?: string;
  participantsCount?: number;
  loadingStation?: string;
  loadingRoad?: string;
  cargoName?: string;
  cargoWeight?: number;
  wagonsType?: string;
  totalWagons?: string;
  myParticipation?: boolean;
}

export interface PageableResponseDTOOrderPageAllTradeSobResponseDTO {
  currentPage?: number;
  totalPage?: number;
  totalItems?: number;
  items?: OrderPageAllTradeSobResponseDTO[];
}

export interface TradeResponseDTOPageableResponseDTOOrderPageAllTradeSobResponseDTO {
  /** @minLength 1 */
  message: string;
  payload?: PageableResponseDTOOrderPageAllTradeSobResponseDTO;
}

export interface AggregateResponseDTO {
  id?: string;
  code?: string;
  description?: string;
  count?: number;
}

export interface TradeResponseDTOListAggregateResponseDTO {
  /** @minLength 1 */
  message: string;
  payload?: AggregateResponseDTO[];
}

export interface AuthResponseDTOUserProfileResponseDTO {
  /** @minLength 1 */
  message: string;
  payload?: UserProfileResponseDTO;
}

export interface CompanyDto {
  id: string;
  /**
   * @minLength 0
   * @maxLength 150
   */
  companyName?: string;
  /**
   * @minLength 0
   * @maxLength 12
   */
  inn?: string;
  /**
   * @minLength 0
   * @maxLength 10
   */
  kpp?: string;
  /**
   * @minLength 0
   * @maxLength 13
   */
  ogrn?: string;
  /**
   * @minLength 0
   * @maxLength 50
   */
  contactNumber?: string;
  /**
   * @minLength 0
   * @maxLength 250
   */
  addressLegal?: string;
  /**
   * @minLength 0
   * @maxLength 250
   */
  addressActual?: string;
  /**
   * @minLength 6
   * @maxLength 100
   */
  companyEmail?: string;
}

export interface UserProfileDTO {
  username: string;
  login: string;
  email: string;
  contactNumber: string;
}

export interface UserProfileResponseDTO {
  userInfo?: UserProfileDTO;
  companyInfo?: CompanyDto;
}

export interface AuthResponseDTOUserInfoDTO {
  /** @minLength 1 */
  message: string;
  payload?: UserInfoDTO;
}

export type UserInfoDTOPermission = {[key: string]: {[key: string]: boolean}};

export interface UserInfoDTO {
  id: string;
  /** @minLength 1 */
  username: string;
  /** @minLength 1 */
  email: string;
  permission: UserInfoDTOPermission;
  accepted?: boolean;
  changePassword?: boolean;
}

export interface OrderStatusDTO {
  id?: string;
  code?: string;
  description?: string;
  sort_order?: number;
}

export interface TradeResponseDTOListOrderStatusDTO {
  /** @minLength 1 */
  message: string;
  payload?: OrderStatusDTO[];
}

export type NotificationDTONotificationType = typeof NotificationDTONotificationType[keyof typeof NotificationDTONotificationType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const NotificationDTONotificationType = {
  APPROVED: 'APPROVED',
  NOTIFICATION: 'NOTIFICATION',
  TRADE: 'TRADE',
  REJECTION: 'REJECTION',
  WINNER: 'WINNER',
} as const;

export interface NotificationDTO {
  id?: string;
  userId?: string;
  title?: string;
  message?: string;
  notificationType?: NotificationDTONotificationType;
  orderId?: string;
  orderNumber?: string;
  createdAt?: string;
  read?: boolean;
}

export interface PageableResponseDTONotificationDTO {
  currentPage?: number;
  totalPage?: number;
  totalItems?: number;
  items?: NotificationDTO[];
}

export interface PageableResponseDTORoadDTO {
  currentPage?: number;
  totalPage?: number;
  totalItems?: number;
  items?: RoadDTO[];
}

export interface RoadDTO {
  name?: string;
  fullName?: string;
  code?: string;
}

export interface TradeResponseDTOPageableResponseDTORoadDTO {
  /** @minLength 1 */
  message: string;
  payload?: PageableResponseDTORoadDTO;
}

export interface PageableResponseDTOStationDTO {
  currentPage?: number;
  totalPage?: number;
  totalItems?: number;
  items?: StationDTO[];
}

export interface StationDTO {
  name?: string;
  road?: string;
  code?: string;
  fullRoad?: RoadDTO;
}

export interface TradeResponseDTOPageableResponseDTOStationDTO {
  /** @minLength 1 */
  message: string;
  payload?: PageableResponseDTOStationDTO;
}

export interface PageableResponseDTOWagonDTO {
  currentPage?: number;
  totalPage?: number;
  totalItems?: number;
  items?: WagonDTO[];
}

export interface TradeResponseDTOPageableResponseDTOWagonDTO {
  /** @minLength 1 */
  message: string;
  payload?: PageableResponseDTOWagonDTO;
}

export interface WagonDTO {
  code?: string;
  model?: string;
  liftingCapacity?: number;
  bodySize?: number;
}

export interface TradeResponseDTOListString {
  /** @minLength 1 */
  message: string;
  payload?: string[];
}

export interface CargoDTO {
  cargoName?: string;
  cargoCode?: string;
}

export interface PageableResponseDTOCargoDTO {
  currentPage?: number;
  totalPage?: number;
  totalItems?: number;
  items?: CargoDTO[];
}

export interface TradeResponseDTOPageableResponseDTOCargoDTO {
  /** @minLength 1 */
  message: string;
  payload?: PageableResponseDTOCargoDTO;
}

export interface ParticipantAgreedWagonsDTO {
  id?: string;
  participantNumber?: number;
  numberAgreedWagons?: number;
  userId?: string;
  companyName?: string;
  countWagonsOwner?: number;
  offers?: ParticipantOfferDTO[];
}

export interface ParticipantOfferDTO {
  wagonTariff?: number;
  indexNumber?: number;
}

export interface TradeResponseDTOWinnersResultResponseDTO {
  /** @minLength 1 */
  message: string;
  payload?: WinnersResultResponseDTO;
}

export type UnloadingDirectionResponseDTOTariffRoad = typeof UnloadingDirectionResponseDTOTariffRoad[keyof typeof UnloadingDirectionResponseDTOTariffRoad];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UnloadingDirectionResponseDTOTariffRoad = {
  WITH_20_VAT: 'WITH_20_VAT',
  WITH_0_VAT: 'WITH_0_VAT',
  WITH_OUT_VAT: 'WITH_OUT_VAT',
  COEFFICIENT: 'COEFFICIENT',
} as const;

export type UnloadingDirectionResponseDTOTariffStation = typeof UnloadingDirectionResponseDTOTariffStation[keyof typeof UnloadingDirectionResponseDTOTariffStation];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const UnloadingDirectionResponseDTOTariffStation = {
  WITH_20_VAT: 'WITH_20_VAT',
  WITH_0_VAT: 'WITH_0_VAT',
  WITH_OUT_VAT: 'WITH_OUT_VAT',
  COEFFICIENT: 'COEFFICIENT',
} as const;

export interface UnloadingDirectionResponseDTO {
  unloadingRoad: RoadDTO;
  tariffRoad?: UnloadingDirectionResponseDTOTariffRoad;
  unloadingStation?: StationDTO;
  countWagons?: number;
  tariffStation?: UnloadingDirectionResponseDTOTariffStation;
  indexNumber?: number;
}

export interface WinnersResultResponseDTO {
  userRole?: string;
  isOrderOwner?: boolean;
  isTradeParticipant?: boolean;
  winnersCompany?: string[];
  directions?: UnloadingDirectionResponseDTO[];
  winners?: ParticipantAgreedWagonsDTO[];
  participant?: ParticipantAgreedWagonsDTO[];
}

export type AllOffersDirectionDTOTariffRoad = typeof AllOffersDirectionDTOTariffRoad[keyof typeof AllOffersDirectionDTOTariffRoad];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AllOffersDirectionDTOTariffRoad = {
  WITH_20_VAT: 'WITH_20_VAT',
  WITH_0_VAT: 'WITH_0_VAT',
  WITH_OUT_VAT: 'WITH_OUT_VAT',
  COEFFICIENT: 'COEFFICIENT',
} as const;

export interface AllOffersDirectionDTO {
  unloadingRoad?: RoadDTO;
  unloadingStation?: StationDTO;
  tariffRoad?: AllOffersDirectionDTOTariffRoad;
  index?: number;
}

export interface MyOffersResponseDTO {
  directions?: AllOffersDirectionDTO[];
  stages?: StageOffersDTO[];
  countWagonsOwner?: number;
  totalWagons?: number;
  responseSign?: boolean;
  allowRetradingRound?: boolean;
}

export interface StageOffersDTO {
  stage?: number;
  ownerOffers?: ParticipantOfferDTO[];
  sobOffers?: ParticipantOfferDTO[];
}

export interface TradeResponseDTOMyOffersResponseDTO {
  /** @minLength 1 */
  message: string;
  payload?: MyOffersResponseDTO;
}

export interface GetOfferOrderDTO {
  listDirection?: OfferOrderDTO[];
  totalWagons?: number;
  countWagonsOwner?: number;
  responseSign?: boolean;
}

export type OfferOrderDTOTariffRoad = typeof OfferOrderDTOTariffRoad[keyof typeof OfferOrderDTOTariffRoad];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OfferOrderDTOTariffRoad = {
  WITH_20_VAT: 'WITH_20_VAT',
  WITH_0_VAT: 'WITH_0_VAT',
  WITH_OUT_VAT: 'WITH_OUT_VAT',
  COEFFICIENT: 'COEFFICIENT',
} as const;

export type OfferOrderDTOTariffStation = typeof OfferOrderDTOTariffStation[keyof typeof OfferOrderDTOTariffStation];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OfferOrderDTOTariffStation = {
  WITH_20_VAT: 'WITH_20_VAT',
  WITH_0_VAT: 'WITH_0_VAT',
  WITH_OUT_VAT: 'WITH_OUT_VAT',
  COEFFICIENT: 'COEFFICIENT',
} as const;

export interface OfferOrderDTO {
  unloadingRoad: RoadDTO;
  tariffRoad?: OfferOrderDTOTariffRoad;
  unloadingStation?: StationDTO;
  countWagons?: number;
  tariffStation?: OfferOrderDTOTariffStation;
  indexNumber?: number;
  wagonTariff?: number;
  createdAt?: string;
}

export interface TradeResponseDTOGetOfferOrderDTO {
  /** @minLength 1 */
  message: string;
  payload?: GetOfferOrderDTO;
}

export type OrderDetailResponseDTOStatus = typeof OrderDetailResponseDTOStatus[keyof typeof OrderDetailResponseDTOStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderDetailResponseDTOStatus = {
  DRAFT: 'DRAFT',
  ON_MODERATION: 'ON_MODERATION',
  ON_REVISION: 'ON_REVISION',
  WAITING_TRADE: 'WAITING_TRADE',
  COLLECT_PROPOSAL: 'COLLECT_PROPOSAL',
  REBIDDING: 'REBIDDING',
  SUMMING_UP: 'SUMMING_UP',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
} as const;

export interface OrderDetailResponseDTO {
  id?: string;
  orderNumber?: string;
  ownerCompanyName?: string;
  orderCreation?: string;
  loadingStation?: StationDTO;
  loadingRoad?: RoadDTO;
  cargoId?: CargoDTO;
  cargoWeight?: number;
  totalWagons?: number;
  unloadingDirection?: UnloadingDirectionResponseDTO[];
  modelId?: WagonDTO;
  wagonType?: string;
  cargoComments?: string;
  standartTimeLoading?: number;
  standartTimeUnloading?: number;
  penalty?: number;
  moratorium?: boolean;
  deadlineAt?: string;
  deadlineTo?: string;
  decade?: boolean;
  decadeFirst?: number;
  decadeSecond?: number;
  decadeThird?: number;
  decadeComments?: string;
  tradeBegin?: string;
  tradeEnd?: string;
  collectionBegin?: string;
  collectionEnd?: string;
  retrading?: boolean;
  retradingBegin?: string;
  retradingEnd?: string;
  resultsDate?: string;
  liftingCapacity?: number;
  bodySize?: number;
  moderationComment?: string;
  moderationRetradingComment?: string;
  status?: OrderDetailResponseDTOStatus;
  isOwner?: boolean;
  isParticipant?: boolean;
  companyHasParticipation?: boolean;
  sameCompanyAsOwner?: boolean;
}

export interface TradeResponseDTOOrderDetailResponseDTO {
  /** @minLength 1 */
  message: string;
  payload?: OrderDetailResponseDTO;
}

export type OrderPageResponseDTOStatus = typeof OrderPageResponseDTOStatus[keyof typeof OrderPageResponseDTOStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderPageResponseDTOStatus = {
  DRAFT: 'DRAFT',
  ON_MODERATION: 'ON_MODERATION',
  ON_REVISION: 'ON_REVISION',
  WAITING_TRADE: 'WAITING_TRADE',
  COLLECT_PROPOSAL: 'COLLECT_PROPOSAL',
  REBIDDING: 'REBIDDING',
  SUMMING_UP: 'SUMMING_UP',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
} as const;

export interface OrderPageResponseDTO {
  id?: string;
  orderNumber?: string;
  loadingStation?: string;
  loadingRoad?: string;
  cargoName?: string;
  cargoWeight?: number;
  wagonsType?: string;
  totalWagons?: string;
  participantsCount?: number;
  status?: OrderPageResponseDTOStatus;
  orderCreation?: string;
  isOwner?: boolean;
}

export interface PageableResponseDTOOrderPageResponseDTO {
  currentPage?: number;
  totalPage?: number;
  totalItems?: number;
  items?: OrderPageResponseDTO[];
}

export interface TradeResponseDTOPageableResponseDTOOrderPageResponseDTO {
  /** @minLength 1 */
  message: string;
  payload?: PageableResponseDTOOrderPageResponseDTO;
}

export interface DraftShortResponseDTO {
  id?: string;
  orderNumber?: string;
  cargoId?: CargoDTO;
  cargoWeight?: number;
  loadingStation?: StationDTO;
}

export interface PageableResponseDTODraftShortResponseDTO {
  currentPage?: number;
  totalPage?: number;
  totalItems?: number;
  items?: DraftShortResponseDTO[];
}

export interface TradeResponseDTOPageableResponseDTODraftShortResponseDTO {
  /** @minLength 1 */
  message: string;
  payload?: PageableResponseDTODraftShortResponseDTO;
}

export type OrderPageAllTradeCargoResponseDTOStatus = typeof OrderPageAllTradeCargoResponseDTOStatus[keyof typeof OrderPageAllTradeCargoResponseDTOStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderPageAllTradeCargoResponseDTOStatus = {
  DRAFT: 'DRAFT',
  ON_MODERATION: 'ON_MODERATION',
  ON_REVISION: 'ON_REVISION',
  WAITING_TRADE: 'WAITING_TRADE',
  COLLECT_PROPOSAL: 'COLLECT_PROPOSAL',
  REBIDDING: 'REBIDDING',
  SUMMING_UP: 'SUMMING_UP',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
} as const;

export interface OrderPageAllTradeCargoResponseDTO {
  id?: string;
  orderNumber?: string;
  tradeBegin?: string;
  tradeEnd?: string;
  status?: OrderPageAllTradeCargoResponseDTOStatus;
  participantsCount?: number;
  loadingStation?: string;
  loadingRoad?: string;
  cargoName?: string;
  cargoWeight?: number;
  wagonsType?: string;
  totalWagons?: number;
  myParticipation?: boolean;
  stageBegin?: string;
  endBegin?: string;
}

export interface PageableResponseDTOOrderPageAllTradeCargoResponseDTO {
  currentPage?: number;
  totalPage?: number;
  totalItems?: number;
  items?: OrderPageAllTradeCargoResponseDTO[];
}

export interface TradeResponseDTOPageableResponseDTOOrderPageAllTradeCargoResponseDTO {
  /** @minLength 1 */
  message: string;
  payload?: PageableResponseDTOOrderPageAllTradeCargoResponseDTO;
}

export interface AllOffersResponseDTO {
  directions?: AllOffersDirectionDTO[];
  participants?: ParticipantOffersDTO[];
  totalWagons?: number;
  round?: number;
  allowRetradingRound?: boolean;
}

export interface ParticipantOffersDTO {
  participantNumber?: number;
  companyName?: string;
  offers?: ParticipantOfferDTO[];
  countWagonsOwner?: number;
}

export interface TradeResponseDTOAllOffersResponseDTO {
  /** @minLength 1 */
  message: string;
  payload?: AllOffersResponseDTO;
}

export interface AuthResponseDTOPageableResponseDTOUserPageItemDTO {
  /** @minLength 1 */
  message: string;
  payload?: PageableResponseDTOUserPageItemDTO;
}

export interface PageableResponseDTOUserPageItemDTO {
  currentPage?: number;
  totalPage?: number;
  totalItems?: number;
  items?: UserPageItemDTO[];
}

export interface UserPageItemDTO {
  id?: string;
  username?: string;
  email?: string;
  companyName?: string;
  inn?: string;
  role?: string;
  createdAt?: string;
  active?: boolean;
}

export interface AuthResponseDTOUserDataDTO {
  /** @minLength 1 */
  message: string;
  payload?: UserDataDTO;
}

export interface UserDataDTO {
  id?: string;
  login?: string;
  username?: string;
  password?: string;
  email?: string;
  role?: string;
  createdAt?: string;
  contactNumber?: string;
  companyName?: string;
  inn?: string;
  kpp?: string;
  ogrn?: string;
  companyContactNumber?: string;
  addressLegal?: string;
  addressActual?: string;
  companyEmail?: string;
}

export interface AuthResponseDTOUserAggregateDTO {
  /** @minLength 1 */
  message: string;
  payload?: UserAggregateDTO;
}

export interface UserAggregateDTO {
  totalUsers?: number;
  blockedUsers?: number;
  adminUsers?: number;
}

export interface AuthResponseDTOUserPermissionDTO {
  /** @minLength 1 */
  message: string;
  payload?: UserPermissionDTO;
}

export interface UserPermissionDTO {
  id: string;
  username?: string;
  role?: string;
  createApplication: boolean;
  extensionOfAuction: boolean;
  cancelApplication: boolean;
  viewingWinners: boolean;
}

export type AdminOrderPageResponseDTOStatus = typeof AdminOrderPageResponseDTOStatus[keyof typeof AdminOrderPageResponseDTOStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const AdminOrderPageResponseDTOStatus = {
  DRAFT: 'DRAFT',
  ON_MODERATION: 'ON_MODERATION',
  ON_REVISION: 'ON_REVISION',
  WAITING_TRADE: 'WAITING_TRADE',
  COLLECT_PROPOSAL: 'COLLECT_PROPOSAL',
  REBIDDING: 'REBIDDING',
  SUMMING_UP: 'SUMMING_UP',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
} as const;

export interface AdminOrderPageResponseDTO {
  id?: string;
  orderNumber?: string;
  tradeBegin?: string;
  tradeEnd?: string;
  loadingStation?: string;
  loadingRoad?: string;
  status?: AdminOrderPageResponseDTOStatus;
  stageBegin?: string;
  stageEnd?: string;
  participantsCount?: number;
  cargoName?: string;
  cargoWeight?: number;
  totalWagons?: number;
  wagonType?: string;
}

export interface PageableResponseDTOAdminOrderPageResponseDTO {
  currentPage?: number;
  totalPage?: number;
  totalItems?: number;
  items?: AdminOrderPageResponseDTO[];
}

export interface TradeResponseDTOPageableResponseDTOAdminOrderPageResponseDTO {
  /** @minLength 1 */
  message: string;
  payload?: PageableResponseDTOAdminOrderPageResponseDTO;
}

export interface OrderContinueRebiddingResponseDTO {
  id?: string;
  orderId?: string;
  orderNumber?: string;
  dayCount?: number;
  tradeBegin?: string;
  tradeEnd?: string;
  orderCreation?: string;
}

export interface TradeResponseDTOListOrderContinueRebiddingResponseDTO {
  /** @minLength 1 */
  message: string;
  payload?: OrderContinueRebiddingResponseDTO[];
}

export interface AdminOrderStatusDTO {
  id?: string;
  status?: string;
}

export interface TradeResponseDTOListAdminOrderStatusDTO {
  /** @minLength 1 */
  message: string;
  payload?: AdminOrderStatusDTO[];
}

export interface AuthResponseDTOCompanyDto {
  /** @minLength 1 */
  message: string;
  payload?: CompanyDto;
}

export interface ApplicantInfoDto {
  username?: string;
  phone?: string;
}

export interface CompanyInfoDto {
  name?: string;
  inn?: string;
}

export interface OnModerationOrderDto {
  orderId?: string;
  orderNumber?: string;
  loadingStation?: string;
  cargoName?: string;
  company?: CompanyInfoDto;
  applicant?: ApplicantInfoDto;
  orderCreation?: string;
}

export interface TradeResponseDTOListOnModerationOrderDto {
  /** @minLength 1 */
  message: string;
  payload?: OnModerationOrderDto[];
}

export type OrderCancelResponseDTOStatuses = typeof OrderCancelResponseDTOStatuses[keyof typeof OrderCancelResponseDTOStatuses];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const OrderCancelResponseDTOStatuses = {
  DRAFT: 'DRAFT',
  ON_MODERATION: 'ON_MODERATION',
  ON_REVISION: 'ON_REVISION',
  WAITING_TRADE: 'WAITING_TRADE',
  COLLECT_PROPOSAL: 'COLLECT_PROPOSAL',
  REBIDDING: 'REBIDDING',
  SUMMING_UP: 'SUMMING_UP',
  COMPLETED: 'COMPLETED',
  CANCELLED: 'CANCELLED',
} as const;

export interface OrderCancelResponseDTO {
  id?: string;
  orderId?: string;
  orderNumber?: string;
  statuses?: OrderCancelResponseDTOStatuses;
  tradeBegin?: string;
  tradeEnd?: string;
  comment?: string;
  creationDate?: string;
}

export interface TradeResponseDTOListOrderCancelResponseDTO {
  /** @minLength 1 */
  message: string;
  payload?: OrderCancelResponseDTO[];
}

export interface TradeResponseDTOListOrderInitiatorDTO {
  /** @minLength 1 */
  message: string;
  payload?: OrderInitiatorDTO[];
}

export interface OrderInitiatorDTO {
  id?: string;
  name?: string;
}

export type MarkAllNotificationsAsReadParams = {
userId: string;
};

export type GetParticipantAgreedWagonsParams = {
orderId: string;
};

export type GetMyOffersParams = {
userId: string;
orderId: string;
};

export type UpDraftParams = {
id: string;
};

export type GetAllOffersParams = {
orderId: string;
};

export type DeleteUserParams = {
userId: string;
};

export type DeleteUser200 = { [key: string]: unknown };

export type SetUserBlocking200 = { [key: string]: unknown };

export type GetUserPermissionParams = {
userId: string;
};

export type SetUserPermission200 = { [key: string]: unknown };

export type AcceptOrder200 = { [key: string]: unknown };

export type AcceptOrder1200 = { [key: string]: unknown };

export type UploadRailstationsBody = {
  file: Blob;
};

export type UploadRailstations201 = { [key: string]: unknown };

export type UploadRailstations400 = { [key: string]: unknown };

export type UploadRailroadsBody = {
  file: Blob;
};

export type UploadRailroads201 = { [key: string]: unknown };

export type UploadRailroads400 = { [key: string]: unknown };

export type UploadRailcoachesBody = {
  file: Blob;
};

export type UploadRailcoaches201 = { [key: string]: unknown };

export type UploadRailcoaches400 = { [key: string]: unknown };

export type UploadEtsngBody = {
  file: Blob;
};

export type UploadEtsng201 = { [key: string]: unknown };

export type UploadEtsng400 = { [key: string]: unknown };

export type ChangeUserPassword200 = { [key: string]: unknown };

export type ApiTest200 = { [key: string]: unknown };

export type GetMyParticipationOrdersParams = {
userId: string;
statusId?: string;
date?: string;
orderNumber?: string;
page: number;
limit: number;
};

export type GetCargoOrdersParams = {
userId: string;
statusId?: string;
date?: string;
orderNumber?: string;
page: number;
limit: number;
};

export type GetWagonOwnerAggregateDataParams = {
userId: string;
};

export type GetUserProfileParams = {
userId: string;
};

export type GetUserInfoParams = {
id: string;
role: GetUserInfoRole;
};

export type GetUserInfoRole = typeof GetUserInfoRole[keyof typeof GetUserInfoRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUserInfoRole = {
  ADMIN: 'ADMIN',
  CARGO_OWNER: 'CARGO_OWNER',
  WAGON_OWNER: 'WAGON_OWNER',
} as const;

export type GetNotificationsParams = {
userId: string;
page: number;
limit: number;
};

export type GetUnreadNotificationCountParams = {
userId: string;
};

export type LoadRoadParams = {
name?: string;
code?: string;
page: number;
limit: number;
};

export type GetRailstationsParams = {
name?: string;
code?: string;
page: number;
limit: number;
};

export type LoadWagonModelParams = {
type: string;
model?: string;
page: number;
limit: number;
};

export type LoadCargoParams = {
name?: string;
code?: string;
page: number;
limit: number;
};

export type GetWinnersResultParams = {
userId: string;
orderId: string;
};

export type GetPivotTableParams = {
orderId: string;
};

export type GetOfferOrderDetailsParams = {
userId: string;
orderId: string;
};

export type GetCargoOrderParams = {
id: string;
userId: string;
};

export type CreateCargoOrder1Params = {
userId: string;
orderDate?: string;
orderNumber?: string;
statusId?: string;
page: number;
limit: number;
};

export type GetDraftsParams = {
id: string;
page: number;
limit: number;
};

export type GetCargoOrdersAllTradeParams = {
userId: string;
statusId?: string;
date?: string;
orderNumber?: string;
page: number;
limit: number;
};

export type GetAggregateDataParams = {
id: string;
};

export type GetUsersParams = {
role?: GetUsersRole;
company?: string;
inn?: string;
isActive?: boolean;
page: number;
limit: number;
};

export type GetUsersRole = typeof GetUsersRole[keyof typeof GetUsersRole];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetUsersRole = {
  ADMIN: 'ADMIN',
  CARGO_OWNER: 'CARGO_OWNER',
  WAGON_OWNER: 'WAGON_OWNER',
} as const;

export type GetUserDataParams = {
userId: string;
};

export type GetAdminOrdersParams = {
page: number;
limit: number;
stage?: string;
creationDate?: string;
orderNumber?: string;
companyIds?: string[];
};

export type GetCompanyParams = {
inn: string;
};

export type DeleteCargoOrderParams = {
id: string;
};

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * @summary Подтверждение соглашение
 */
export type acceptTermResponse200 = {
  data: AuthResponseDTOObject
  status: 200
}
    
export type acceptTermResponseSuccess = (acceptTermResponse200) & {
  headers: Headers;
};
;

export type acceptTermResponse = (acceptTermResponseSuccess)

export const getAcceptTermUrl = () => {


  

  return `https://etp.it4prof.ru/api/user/accept-terms`
}

export const acceptTerm = async (acceptUserDTO: AcceptUserDTO, options?: RequestInit): Promise<acceptTermResponse> => {
  
  return customFetch<acceptTermResponse>(getAcceptTermUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      acceptUserDTO,)
  }
);}




export const getAcceptTermMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptTerm>>, TError,{data: AcceptUserDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptTerm>>, TError,{data: AcceptUserDTO}, TContext> => {

const mutationKey = ['acceptTerm'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptTerm>>, {data: AcceptUserDTO}> = (props) => {
          const {data} = props ?? {};

          return  acceptTerm(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcceptTermMutationResult = NonNullable<Awaited<ReturnType<typeof acceptTerm>>>
    export type AcceptTermMutationBody = AcceptUserDTO
    export type AcceptTermMutationError = unknown

    /**
 * @summary Подтверждение соглашение
 */
export const useAcceptTerm = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptTerm>>, TError,{data: AcceptUserDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acceptTerm>>,
        TError,
        {data: AcceptUserDTO},
        TContext
      > => {

      const mutationOptions = getAcceptTermMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Пометить уведомления как прочитанные
 */
export type markNotificationsAsReadResponse200 = {
  data: void
  status: 200
}
    
export type markNotificationsAsReadResponseSuccess = (markNotificationsAsReadResponse200) & {
  headers: Headers;
};
;

export type markNotificationsAsReadResponse = (markNotificationsAsReadResponseSuccess)

export const getMarkNotificationsAsReadUrl = () => {


  

  return `https://etp.it4prof.ru/api/notification/mark-read`
}

export const markNotificationsAsRead = async (markNotificationsAsReadBody: string[], options?: RequestInit): Promise<markNotificationsAsReadResponse> => {
  
  return customFetch<markNotificationsAsReadResponse>(getMarkNotificationsAsReadUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      markNotificationsAsReadBody,)
  }
);}




export const getMarkNotificationsAsReadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markNotificationsAsRead>>, TError,{data: string[]}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markNotificationsAsRead>>, TError,{data: string[]}, TContext> => {

const mutationKey = ['markNotificationsAsRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markNotificationsAsRead>>, {data: string[]}> = (props) => {
          const {data} = props ?? {};

          return  markNotificationsAsRead(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MarkNotificationsAsReadMutationResult = NonNullable<Awaited<ReturnType<typeof markNotificationsAsRead>>>
    export type MarkNotificationsAsReadMutationBody = string[]
    export type MarkNotificationsAsReadMutationError = unknown

    /**
 * @summary Пометить уведомления как прочитанные
 */
export const useMarkNotificationsAsRead = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markNotificationsAsRead>>, TError,{data: string[]}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markNotificationsAsRead>>,
        TError,
        {data: string[]},
        TContext
      > => {

      const mutationOptions = getMarkNotificationsAsReadMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Пометить все непрочитанные уведомления как прочитанные
 */
export type markAllNotificationsAsReadResponse200 = {
  data: void
  status: 200
}
    
export type markAllNotificationsAsReadResponseSuccess = (markAllNotificationsAsReadResponse200) & {
  headers: Headers;
};
;

export type markAllNotificationsAsReadResponse = (markAllNotificationsAsReadResponseSuccess)

export const getMarkAllNotificationsAsReadUrl = (params: MarkAllNotificationsAsReadParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://etp.it4prof.ru/api/notification/mark-all?${stringifiedParams}` : `https://etp.it4prof.ru/api/notification/mark-all`
}

export const markAllNotificationsAsRead = async (params: MarkAllNotificationsAsReadParams, options?: RequestInit): Promise<markAllNotificationsAsReadResponse> => {
  
  return customFetch<markAllNotificationsAsReadResponse>(getMarkAllNotificationsAsReadUrl(params),
  {      
    ...options,
    method: 'PUT'
    
    
  }
);}




export const getMarkAllNotificationsAsReadMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAllNotificationsAsRead>>, TError,{params: MarkAllNotificationsAsReadParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof markAllNotificationsAsRead>>, TError,{params: MarkAllNotificationsAsReadParams}, TContext> => {

const mutationKey = ['markAllNotificationsAsRead'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof markAllNotificationsAsRead>>, {params: MarkAllNotificationsAsReadParams}> = (props) => {
          const {params} = props ?? {};

          return  markAllNotificationsAsRead(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type MarkAllNotificationsAsReadMutationResult = NonNullable<Awaited<ReturnType<typeof markAllNotificationsAsRead>>>
    
    export type MarkAllNotificationsAsReadMutationError = unknown

    /**
 * @summary Пометить все непрочитанные уведомления как прочитанные
 */
export const useMarkAllNotificationsAsRead = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof markAllNotificationsAsRead>>, TError,{params: MarkAllNotificationsAsReadParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof markAllNotificationsAsRead>>,
        TError,
        {params: MarkAllNotificationsAsReadParams},
        TContext
      > => {

      const mutationOptions = getMarkAllNotificationsAsReadMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Ответ на предложение по заказу
 */
export type offerResponseResponse200 = {
  data: TradeResponseDTOObject
  status: 200
}
    
export type offerResponseResponseSuccess = (offerResponseResponse200) & {
  headers: Headers;
};
;

export type offerResponseResponse = (offerResponseResponseSuccess)

export const getOfferResponseUrl = () => {


  

  return `https://etp.it4prof.ru/api/cargo/order/offer/response`
}

export const offerResponse = async (offerResponseDTO: OfferResponseDTO, options?: RequestInit): Promise<offerResponseResponse> => {
  
  return customFetch<offerResponseResponse>(getOfferResponseUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      offerResponseDTO,)
  }
);}




export const getOfferResponseMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerResponse>>, TError,{data: OfferResponseDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof offerResponse>>, TError,{data: OfferResponseDTO}, TContext> => {

const mutationKey = ['offerResponse'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof offerResponse>>, {data: OfferResponseDTO}> = (props) => {
          const {data} = props ?? {};

          return  offerResponse(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type OfferResponseMutationResult = NonNullable<Awaited<ReturnType<typeof offerResponse>>>
    export type OfferResponseMutationBody = OfferResponseDTO
    export type OfferResponseMutationError = unknown

    /**
 * @summary Ответ на предложение по заказу
 */
export const useOfferResponse = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof offerResponse>>, TError,{data: OfferResponseDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof offerResponse>>,
        TError,
        {data: OfferResponseDTO},
        TContext
      > => {

      const mutationOptions = getOfferResponseMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Получение списка участников с согласованными вагонами по заказу
 */
export type getParticipantAgreedWagonsResponse200 = {
  data: TradeResponseDTOObject
  status: 200
}
    
export type getParticipantAgreedWagonsResponseSuccess = (getParticipantAgreedWagonsResponse200) & {
  headers: Headers;
};
;

export type getParticipantAgreedWagonsResponse = (getParticipantAgreedWagonsResponseSuccess)

export const getGetParticipantAgreedWagonsUrl = (params: GetParticipantAgreedWagonsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://etp.it4prof.ru/api/cargo/order/offer/participant-agreed-wagons?${stringifiedParams}` : `https://etp.it4prof.ru/api/cargo/order/offer/participant-agreed-wagons`
}

export const getParticipantAgreedWagons = async (params: GetParticipantAgreedWagonsParams, options?: RequestInit): Promise<getParticipantAgreedWagonsResponse> => {
  
  return customFetch<getParticipantAgreedWagonsResponse>(getGetParticipantAgreedWagonsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetParticipantAgreedWagonsQueryKey = (params?: GetParticipantAgreedWagonsParams,) => {
    return [
    `https://etp.it4prof.ru/api/cargo/order/offer/participant-agreed-wagons`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetParticipantAgreedWagonsQueryOptions = <TData = Awaited<ReturnType<typeof getParticipantAgreedWagons>>, TError = unknown>(params: GetParticipantAgreedWagonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getParticipantAgreedWagons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetParticipantAgreedWagonsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getParticipantAgreedWagons>>> = ({ signal }) => getParticipantAgreedWagons(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getParticipantAgreedWagons>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetParticipantAgreedWagonsQueryResult = NonNullable<Awaited<ReturnType<typeof getParticipantAgreedWagons>>>
export type GetParticipantAgreedWagonsQueryError = unknown


export function useGetParticipantAgreedWagons<TData = Awaited<ReturnType<typeof getParticipantAgreedWagons>>, TError = unknown>(
 params: GetParticipantAgreedWagonsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getParticipantAgreedWagons>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getParticipantAgreedWagons>>,
          TError,
          Awaited<ReturnType<typeof getParticipantAgreedWagons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetParticipantAgreedWagons<TData = Awaited<ReturnType<typeof getParticipantAgreedWagons>>, TError = unknown>(
 params: GetParticipantAgreedWagonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getParticipantAgreedWagons>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getParticipantAgreedWagons>>,
          TError,
          Awaited<ReturnType<typeof getParticipantAgreedWagons>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetParticipantAgreedWagons<TData = Awaited<ReturnType<typeof getParticipantAgreedWagons>>, TError = unknown>(
 params: GetParticipantAgreedWagonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getParticipantAgreedWagons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Получение списка участников с согласованными вагонами по заказу
 */

export function useGetParticipantAgreedWagons<TData = Awaited<ReturnType<typeof getParticipantAgreedWagons>>, TError = unknown>(
 params: GetParticipantAgreedWagonsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getParticipantAgreedWagons>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetParticipantAgreedWagonsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Сохранение согласованных вагонов участников по заказу
 */
export type saveParticipantAgreedWagonsResponse200 = {
  data: TradeResponseDTOObject
  status: 200
}
    
export type saveParticipantAgreedWagonsResponseSuccess = (saveParticipantAgreedWagonsResponse200) & {
  headers: Headers;
};
;

export type saveParticipantAgreedWagonsResponse = (saveParticipantAgreedWagonsResponseSuccess)

export const getSaveParticipantAgreedWagonsUrl = () => {


  

  return `https://etp.it4prof.ru/api/cargo/order/offer/participant-agreed-wagons`
}

export const saveParticipantAgreedWagons = async (participantAgreedWagonsSaveRequestDTO: ParticipantAgreedWagonsSaveRequestDTO, options?: RequestInit): Promise<saveParticipantAgreedWagonsResponse> => {
  
  return customFetch<saveParticipantAgreedWagonsResponse>(getSaveParticipantAgreedWagonsUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      participantAgreedWagonsSaveRequestDTO,)
  }
);}




export const getSaveParticipantAgreedWagonsMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveParticipantAgreedWagons>>, TError,{data: ParticipantAgreedWagonsSaveRequestDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveParticipantAgreedWagons>>, TError,{data: ParticipantAgreedWagonsSaveRequestDTO}, TContext> => {

const mutationKey = ['saveParticipantAgreedWagons'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveParticipantAgreedWagons>>, {data: ParticipantAgreedWagonsSaveRequestDTO}> = (props) => {
          const {data} = props ?? {};

          return  saveParticipantAgreedWagons(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaveParticipantAgreedWagonsMutationResult = NonNullable<Awaited<ReturnType<typeof saveParticipantAgreedWagons>>>
    export type SaveParticipantAgreedWagonsMutationBody = ParticipantAgreedWagonsSaveRequestDTO
    export type SaveParticipantAgreedWagonsMutationError = unknown

    /**
 * @summary Сохранение согласованных вагонов участников по заказу
 */
export const useSaveParticipantAgreedWagons = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveParticipantAgreedWagons>>, TError,{data: ParticipantAgreedWagonsSaveRequestDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveParticipantAgreedWagons>>,
        TError,
        {data: ParticipantAgreedWagonsSaveRequestDTO},
        TContext
      > => {

      const mutationOptions = getSaveParticipantAgreedWagonsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Получение своих предложений по заказу
 */
export type getMyOffersResponse200 = {
  data: TradeResponseDTOMyOffersResponseDTO
  status: 200
}
    
export type getMyOffersResponseSuccess = (getMyOffersResponse200) & {
  headers: Headers;
};
;

export type getMyOffersResponse = (getMyOffersResponseSuccess)

export const getGetMyOffersUrl = (params: GetMyOffersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://etp.it4prof.ru/api/cargo/order/offer/my-offers?${stringifiedParams}` : `https://etp.it4prof.ru/api/cargo/order/offer/my-offers`
}

export const getMyOffers = async (params: GetMyOffersParams, options?: RequestInit): Promise<getMyOffersResponse> => {
  
  return customFetch<getMyOffersResponse>(getGetMyOffersUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetMyOffersQueryKey = (params?: GetMyOffersParams,) => {
    return [
    `https://etp.it4prof.ru/api/cargo/order/offer/my-offers`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetMyOffersQueryOptions = <TData = Awaited<ReturnType<typeof getMyOffers>>, TError = unknown>(params: GetMyOffersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyOffers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyOffersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyOffers>>> = ({ signal }) => getMyOffers(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyOffers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetMyOffersQueryResult = NonNullable<Awaited<ReturnType<typeof getMyOffers>>>
export type GetMyOffersQueryError = unknown


export function useGetMyOffers<TData = Awaited<ReturnType<typeof getMyOffers>>, TError = unknown>(
 params: GetMyOffersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyOffers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyOffers>>,
          TError,
          Awaited<ReturnType<typeof getMyOffers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMyOffers<TData = Awaited<ReturnType<typeof getMyOffers>>, TError = unknown>(
 params: GetMyOffersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyOffers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyOffers>>,
          TError,
          Awaited<ReturnType<typeof getMyOffers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMyOffers<TData = Awaited<ReturnType<typeof getMyOffers>>, TError = unknown>(
 params: GetMyOffersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyOffers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Получение своих предложений по заказу
 */

export function useGetMyOffers<TData = Awaited<ReturnType<typeof getMyOffers>>, TError = unknown>(
 params: GetMyOffersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyOffers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetMyOffersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Сохранение своих предложений как СОБ для переторжки по заказу
 */
export type saveMyOffersResponse200 = {
  data: TradeResponseDTOObject
  status: 200
}
    
export type saveMyOffersResponseSuccess = (saveMyOffersResponse200) & {
  headers: Headers;
};
;

export type saveMyOffersResponse = (saveMyOffersResponseSuccess)

export const getSaveMyOffersUrl = () => {


  

  return `https://etp.it4prof.ru/api/cargo/order/offer/my-offers`
}

export const saveMyOffers = async (myOffersSaveRequestDTO: MyOffersSaveRequestDTO, options?: RequestInit): Promise<saveMyOffersResponse> => {
  
  return customFetch<saveMyOffersResponse>(getSaveMyOffersUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      myOffersSaveRequestDTO,)
  }
);}




export const getSaveMyOffersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveMyOffers>>, TError,{data: MyOffersSaveRequestDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveMyOffers>>, TError,{data: MyOffersSaveRequestDTO}, TContext> => {

const mutationKey = ['saveMyOffers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveMyOffers>>, {data: MyOffersSaveRequestDTO}> = (props) => {
          const {data} = props ?? {};

          return  saveMyOffers(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaveMyOffersMutationResult = NonNullable<Awaited<ReturnType<typeof saveMyOffers>>>
    export type SaveMyOffersMutationBody = MyOffersSaveRequestDTO
    export type SaveMyOffersMutationError = unknown

    /**
 * @summary Сохранение своих предложений как СОБ для переторжки по заказу
 */
export const useSaveMyOffers = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveMyOffers>>, TError,{data: MyOffersSaveRequestDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveMyOffers>>,
        TError,
        {data: MyOffersSaveRequestDTO},
        TContext
      > => {

      const mutationOptions = getSaveMyOffersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Отправка заявки в статусе черновик на модерацю
 */
export type upDraftResponse200 = {
  data: TradeResponseDTOObject
  status: 200
}
    
export type upDraftResponseSuccess = (upDraftResponse200) & {
  headers: Headers;
};
;

export type upDraftResponse = (upDraftResponseSuccess)

export const getUpDraftUrl = (params: UpDraftParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://etp.it4prof.ru/api/cargo/order/draft?${stringifiedParams}` : `https://etp.it4prof.ru/api/cargo/order/draft`
}

export const upDraft = async (params: UpDraftParams, options?: RequestInit): Promise<upDraftResponse> => {
  
  return customFetch<upDraftResponse>(getUpDraftUrl(params),
  {      
    ...options,
    method: 'PUT'
    
    
  }
);}




export const getUpDraftMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upDraft>>, TError,{params: UpDraftParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof upDraft>>, TError,{params: UpDraftParams}, TContext> => {

const mutationKey = ['upDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof upDraft>>, {params: UpDraftParams}> = (props) => {
          const {params} = props ?? {};

          return  upDraft(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpDraftMutationResult = NonNullable<Awaited<ReturnType<typeof upDraft>>>
    
    export type UpDraftMutationError = unknown

    /**
 * @summary Отправка заявки в статусе черновик на модерацю
 */
export const useUpDraft = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof upDraft>>, TError,{params: UpDraftParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof upDraft>>,
        TError,
        {params: UpDraftParams},
        TContext
      > => {

      const mutationOptions = getUpDraftMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Создание черновика
 */
export type createCargoDraftResponse201 = {
  data: TradeResponseDTOObject
  status: 201
}
    
export type createCargoDraftResponseSuccess = (createCargoDraftResponse201) & {
  headers: Headers;
};
;

export type createCargoDraftResponse = (createCargoDraftResponseSuccess)

export const getCreateCargoDraftUrl = () => {


  

  return `https://etp.it4prof.ru/api/cargo/order/draft`
}

export const createCargoDraft = async (draftOrderDto: DraftOrderDto, options?: RequestInit): Promise<createCargoDraftResponse> => {
  
  return customFetch<createCargoDraftResponse>(getCreateCargoDraftUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      draftOrderDto,)
  }
);}




export const getCreateCargoDraftMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCargoDraft>>, TError,{data: DraftOrderDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCargoDraft>>, TError,{data: DraftOrderDto}, TContext> => {

const mutationKey = ['createCargoDraft'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCargoDraft>>, {data: DraftOrderDto}> = (props) => {
          const {data} = props ?? {};

          return  createCargoDraft(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateCargoDraftMutationResult = NonNullable<Awaited<ReturnType<typeof createCargoDraft>>>
    export type CreateCargoDraftMutationBody = DraftOrderDto
    export type CreateCargoDraftMutationError = unknown

    /**
 * @summary Создание черновика
 */
export const useCreateCargoDraft = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCargoDraft>>, TError,{data: DraftOrderDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCargoDraft>>,
        TError,
        {data: DraftOrderDto},
        TContext
      > => {

      const mutationOptions = getCreateCargoDraftMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Отправка заявки модератору на отмену
 */
export type cancelOrderRequestResponse200 = {
  data: TradeResponseDTOObject
  status: 200
}
    
export type cancelOrderRequestResponseSuccess = (cancelOrderRequestResponse200) & {
  headers: Headers;
};
;

export type cancelOrderRequestResponse = (cancelOrderRequestResponseSuccess)

export const getCancelOrderRequestUrl = () => {


  

  return `https://etp.it4prof.ru/api/cargo/order/cancel`
}

export const cancelOrderRequest = async (orderCancelRequestDTO: OrderCancelRequestDTO, options?: RequestInit): Promise<cancelOrderRequestResponse> => {
  
  return customFetch<cancelOrderRequestResponse>(getCancelOrderRequestUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      orderCancelRequestDTO,)
  }
);}




export const getCancelOrderRequestMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelOrderRequest>>, TError,{data: OrderCancelRequestDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof cancelOrderRequest>>, TError,{data: OrderCancelRequestDTO}, TContext> => {

const mutationKey = ['cancelOrderRequest'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof cancelOrderRequest>>, {data: OrderCancelRequestDTO}> = (props) => {
          const {data} = props ?? {};

          return  cancelOrderRequest(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CancelOrderRequestMutationResult = NonNullable<Awaited<ReturnType<typeof cancelOrderRequest>>>
    export type CancelOrderRequestMutationBody = OrderCancelRequestDTO
    export type CancelOrderRequestMutationError = unknown

    /**
 * @summary Отправка заявки модератору на отмену
 */
export const useCancelOrderRequest = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof cancelOrderRequest>>, TError,{data: OrderCancelRequestDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof cancelOrderRequest>>,
        TError,
        {data: OrderCancelRequestDTO},
        TContext
      > => {

      const mutationOptions = getCancelOrderRequestMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Получение всех предложений по заказу от СОБ
 */
export type getAllOffersResponse200 = {
  data: TradeResponseDTOAllOffersResponseDTO
  status: 200
}
    
export type getAllOffersResponseSuccess = (getAllOffersResponse200) & {
  headers: Headers;
};
;

export type getAllOffersResponse = (getAllOffersResponseSuccess)

export const getGetAllOffersUrl = (params: GetAllOffersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://etp.it4prof.ru/api/cargo/order/all-offers?${stringifiedParams}` : `https://etp.it4prof.ru/api/cargo/order/all-offers`
}

export const getAllOffers = async (params: GetAllOffersParams, options?: RequestInit): Promise<getAllOffersResponse> => {
  
  return customFetch<getAllOffersResponse>(getGetAllOffersUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAllOffersQueryKey = (params?: GetAllOffersParams,) => {
    return [
    `https://etp.it4prof.ru/api/cargo/order/all-offers`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAllOffersQueryOptions = <TData = Awaited<ReturnType<typeof getAllOffers>>, TError = unknown>(params: GetAllOffersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOffers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllOffersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllOffers>>> = ({ signal }) => getAllOffers(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllOffers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllOffersQueryResult = NonNullable<Awaited<ReturnType<typeof getAllOffers>>>
export type GetAllOffersQueryError = unknown


export function useGetAllOffers<TData = Awaited<ReturnType<typeof getAllOffers>>, TError = unknown>(
 params: GetAllOffersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOffers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllOffers>>,
          TError,
          Awaited<ReturnType<typeof getAllOffers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllOffers<TData = Awaited<ReturnType<typeof getAllOffers>>, TError = unknown>(
 params: GetAllOffersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOffers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllOffers>>,
          TError,
          Awaited<ReturnType<typeof getAllOffers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllOffers<TData = Awaited<ReturnType<typeof getAllOffers>>, TError = unknown>(
 params: GetAllOffersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOffers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Получение всех предложений по заказу от СОБ
 */

export function useGetAllOffers<TData = Awaited<ReturnType<typeof getAllOffers>>, TError = unknown>(
 params: GetAllOffersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOffers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllOffersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Встречное предложение ГВ на отклики по заказу
 */
export type saveAllOffersResponse200 = {
  data: TradeResponseDTOObject
  status: 200
}
    
export type saveAllOffersResponseSuccess = (saveAllOffersResponse200) & {
  headers: Headers;
};
;

export type saveAllOffersResponse = (saveAllOffersResponseSuccess)

export const getSaveAllOffersUrl = () => {


  

  return `https://etp.it4prof.ru/api/cargo/order/all-offers`
}

export const saveAllOffers = async (allOffersSaveRequestDTO: AllOffersSaveRequestDTO, options?: RequestInit): Promise<saveAllOffersResponse> => {
  
  return customFetch<saveAllOffersResponse>(getSaveAllOffersUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      allOffersSaveRequestDTO,)
  }
);}




export const getSaveAllOffersMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveAllOffers>>, TError,{data: AllOffersSaveRequestDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof saveAllOffers>>, TError,{data: AllOffersSaveRequestDTO}, TContext> => {

const mutationKey = ['saveAllOffers'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof saveAllOffers>>, {data: AllOffersSaveRequestDTO}> = (props) => {
          const {data} = props ?? {};

          return  saveAllOffers(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SaveAllOffersMutationResult = NonNullable<Awaited<ReturnType<typeof saveAllOffers>>>
    export type SaveAllOffersMutationBody = AllOffersSaveRequestDTO
    export type SaveAllOffersMutationError = unknown

    /**
 * @summary Встречное предложение ГВ на отклики по заказу
 */
export const useSaveAllOffers = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof saveAllOffers>>, TError,{data: AllOffersSaveRequestDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof saveAllOffers>>,
        TError,
        {data: AllOffersSaveRequestDTO},
        TContext
      > => {

      const mutationOptions = getSaveAllOffersMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Редактирование данных пользователя и его компании
 */
export type editUserDataResponse200 = {
  data: AuthResponseDTOObject
  status: 200
}
    
export type editUserDataResponseSuccess = (editUserDataResponse200) & {
  headers: Headers;
};
;

export type editUserDataResponse = (editUserDataResponseSuccess)

export const getEditUserDataUrl = () => {


  

  return `https://etp.it4prof.ru/api/admin/user-edit-data`
}

export const editUserData = async (userEditDataDTO: UserEditDataDTO, options?: RequestInit): Promise<editUserDataResponse> => {
  
  return customFetch<editUserDataResponse>(getEditUserDataUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      userEditDataDTO,)
  }
);}




export const getEditUserDataMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editUserData>>, TError,{data: UserEditDataDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof editUserData>>, TError,{data: UserEditDataDTO}, TContext> => {

const mutationKey = ['editUserData'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof editUserData>>, {data: UserEditDataDTO}> = (props) => {
          const {data} = props ?? {};

          return  editUserData(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type EditUserDataMutationResult = NonNullable<Awaited<ReturnType<typeof editUserData>>>
    export type EditUserDataMutationBody = UserEditDataDTO
    export type EditUserDataMutationError = unknown

    /**
 * @summary Редактирование данных пользователя и его компании
 */
export const useEditUserData = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof editUserData>>, TError,{data: UserEditDataDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof editUserData>>,
        TError,
        {data: UserEditDataDTO},
        TContext
      > => {

      const mutationOptions = getEditUserDataMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Удаление пользователя (soft delete)
 */
export type deleteUserResponse200 = {
  data: DeleteUser200
  status: 200
}
    
export type deleteUserResponseSuccess = (deleteUserResponse200) & {
  headers: Headers;
};
;

export type deleteUserResponse = (deleteUserResponseSuccess)

export const getDeleteUserUrl = (params: DeleteUserParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://etp.it4prof.ru/api/admin/user-delete?${stringifiedParams}` : `https://etp.it4prof.ru/api/admin/user-delete`
}

export const deleteUser = async (params: DeleteUserParams, options?: RequestInit): Promise<deleteUserResponse> => {
  
  return customFetch<deleteUserResponse>(getDeleteUserUrl(params),
  {      
    ...options,
    method: 'PUT'
    
    
  }
);}




export const getDeleteUserMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{params: DeleteUserParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{params: DeleteUserParams}, TContext> => {

const mutationKey = ['deleteUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteUser>>, {params: DeleteUserParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteUser(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteUserMutationResult = NonNullable<Awaited<ReturnType<typeof deleteUser>>>
    
    export type DeleteUserMutationError = unknown

    /**
 * @summary Удаление пользователя (soft delete)
 */
export const useDeleteUser = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteUser>>, TError,{params: DeleteUserParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteUser>>,
        TError,
        {params: DeleteUserParams},
        TContext
      > => {

      const mutationOptions = getDeleteUserMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Блокировка/разблокировка пользователя
 */
export type setUserBlockingResponse200 = {
  data: SetUserBlocking200
  status: 200
}
    
export type setUserBlockingResponseSuccess = (setUserBlockingResponse200) & {
  headers: Headers;
};
;

export type setUserBlockingResponse = (setUserBlockingResponseSuccess)

export const getSetUserBlockingUrl = () => {


  

  return `https://etp.it4prof.ru/api/admin/user-blocking`
}

export const setUserBlocking = async (setUserBlockingDTO: SetUserBlockingDTO, options?: RequestInit): Promise<setUserBlockingResponse> => {
  
  return customFetch<setUserBlockingResponse>(getSetUserBlockingUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      setUserBlockingDTO,)
  }
);}




export const getSetUserBlockingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setUserBlocking>>, TError,{data: SetUserBlockingDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setUserBlocking>>, TError,{data: SetUserBlockingDTO}, TContext> => {

const mutationKey = ['setUserBlocking'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setUserBlocking>>, {data: SetUserBlockingDTO}> = (props) => {
          const {data} = props ?? {};

          return  setUserBlocking(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetUserBlockingMutationResult = NonNullable<Awaited<ReturnType<typeof setUserBlocking>>>
    export type SetUserBlockingMutationBody = SetUserBlockingDTO
    export type SetUserBlockingMutationError = unknown

    /**
 * @summary Блокировка/разблокировка пользователя
 */
export const useSetUserBlocking = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setUserBlocking>>, TError,{data: SetUserBlockingDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setUserBlocking>>,
        TError,
        {data: SetUserBlockingDTO},
        TContext
      > => {

      const mutationOptions = getSetUserBlockingMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Получение доступов по действиям
 */
export type getUserPermissionResponse200 = {
  data: AuthResponseDTOUserPermissionDTO
  status: 200
}
    
export type getUserPermissionResponseSuccess = (getUserPermissionResponse200) & {
  headers: Headers;
};
;

export type getUserPermissionResponse = (getUserPermissionResponseSuccess)

export const getGetUserPermissionUrl = (params: GetUserPermissionParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://etp.it4prof.ru/api/admin/permission?${stringifiedParams}` : `https://etp.it4prof.ru/api/admin/permission`
}

export const getUserPermission = async (params: GetUserPermissionParams, options?: RequestInit): Promise<getUserPermissionResponse> => {
  
  return customFetch<getUserPermissionResponse>(getGetUserPermissionUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetUserPermissionQueryKey = (params?: GetUserPermissionParams,) => {
    return [
    `https://etp.it4prof.ru/api/admin/permission`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetUserPermissionQueryOptions = <TData = Awaited<ReturnType<typeof getUserPermission>>, TError = unknown>(params: GetUserPermissionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserPermission>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserPermissionQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserPermission>>> = ({ signal }) => getUserPermission(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserPermission>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetUserPermissionQueryResult = NonNullable<Awaited<ReturnType<typeof getUserPermission>>>
export type GetUserPermissionQueryError = unknown


export function useGetUserPermission<TData = Awaited<ReturnType<typeof getUserPermission>>, TError = unknown>(
 params: GetUserPermissionParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserPermission>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserPermission>>,
          TError,
          Awaited<ReturnType<typeof getUserPermission>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUserPermission<TData = Awaited<ReturnType<typeof getUserPermission>>, TError = unknown>(
 params: GetUserPermissionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserPermission>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserPermission>>,
          TError,
          Awaited<ReturnType<typeof getUserPermission>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUserPermission<TData = Awaited<ReturnType<typeof getUserPermission>>, TError = unknown>(
 params: GetUserPermissionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserPermission>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Получение доступов по действиям
 */

export function useGetUserPermission<TData = Awaited<ReturnType<typeof getUserPermission>>, TError = unknown>(
 params: GetUserPermissionParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserPermission>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetUserPermissionQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Изменение доступов по действиям
 */
export type setUserPermissionResponse200 = {
  data: SetUserPermission200
  status: 200
}
    
export type setUserPermissionResponseSuccess = (setUserPermissionResponse200) & {
  headers: Headers;
};
;

export type setUserPermissionResponse = (setUserPermissionResponseSuccess)

export const getSetUserPermissionUrl = () => {


  

  return `https://etp.it4prof.ru/api/admin/permission`
}

export const setUserPermission = async (setUserPermissionDTO: SetUserPermissionDTO, options?: RequestInit): Promise<setUserPermissionResponse> => {
  
  return customFetch<setUserPermissionResponse>(getSetUserPermissionUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      setUserPermissionDTO,)
  }
);}




export const getSetUserPermissionMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setUserPermission>>, TError,{data: SetUserPermissionDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof setUserPermission>>, TError,{data: SetUserPermissionDTO}, TContext> => {

const mutationKey = ['setUserPermission'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setUserPermission>>, {data: SetUserPermissionDTO}> = (props) => {
          const {data} = props ?? {};

          return  setUserPermission(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetUserPermissionMutationResult = NonNullable<Awaited<ReturnType<typeof setUserPermission>>>
    export type SetUserPermissionMutationBody = SetUserPermissionDTO
    export type SetUserPermissionMutationError = unknown

    /**
 * @summary Изменение доступов по действиям
 */
export const useSetUserPermission = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setUserPermission>>, TError,{data: SetUserPermissionDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setUserPermission>>,
        TError,
        {data: SetUserPermissionDTO},
        TContext
      > => {

      const mutationOptions = getSetUserPermissionMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Получение списка запросов на продление торгов с approved = null
 */
export type getContinueRebiddingRequestsResponse200 = {
  data: TradeResponseDTOListOrderContinueRebiddingResponseDTO
  status: 200
}
    
export type getContinueRebiddingRequestsResponseSuccess = (getContinueRebiddingRequestsResponse200) & {
  headers: Headers;
};
;

export type getContinueRebiddingRequestsResponse = (getContinueRebiddingRequestsResponseSuccess)

export const getGetContinueRebiddingRequestsUrl = () => {


  

  return `https://etp.it4prof.ru/api/admin/order/continue-rebidding`
}

export const getContinueRebiddingRequests = async ( options?: RequestInit): Promise<getContinueRebiddingRequestsResponse> => {
  
  return customFetch<getContinueRebiddingRequestsResponse>(getGetContinueRebiddingRequestsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetContinueRebiddingRequestsQueryKey = () => {
    return [
    `https://etp.it4prof.ru/api/admin/order/continue-rebidding`
    ] as const;
    }

    
export const getGetContinueRebiddingRequestsQueryOptions = <TData = Awaited<ReturnType<typeof getContinueRebiddingRequests>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContinueRebiddingRequests>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetContinueRebiddingRequestsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getContinueRebiddingRequests>>> = ({ signal }) => getContinueRebiddingRequests({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getContinueRebiddingRequests>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetContinueRebiddingRequestsQueryResult = NonNullable<Awaited<ReturnType<typeof getContinueRebiddingRequests>>>
export type GetContinueRebiddingRequestsQueryError = unknown


export function useGetContinueRebiddingRequests<TData = Awaited<ReturnType<typeof getContinueRebiddingRequests>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContinueRebiddingRequests>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContinueRebiddingRequests>>,
          TError,
          Awaited<ReturnType<typeof getContinueRebiddingRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetContinueRebiddingRequests<TData = Awaited<ReturnType<typeof getContinueRebiddingRequests>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContinueRebiddingRequests>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getContinueRebiddingRequests>>,
          TError,
          Awaited<ReturnType<typeof getContinueRebiddingRequests>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetContinueRebiddingRequests<TData = Awaited<ReturnType<typeof getContinueRebiddingRequests>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContinueRebiddingRequests>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Получение списка запросов на продление торгов с approved = null
 */

export function useGetContinueRebiddingRequests<TData = Awaited<ReturnType<typeof getContinueRebiddingRequests>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getContinueRebiddingRequests>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetContinueRebiddingRequestsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Одобрение/отклонение запроса на продление торгов
 */
export type approveContinueRebiddingResponse200 = {
  data: TradeResponseDTOObject
  status: 200
}
    
export type approveContinueRebiddingResponseSuccess = (approveContinueRebiddingResponse200) & {
  headers: Headers;
};
;

export type approveContinueRebiddingResponse = (approveContinueRebiddingResponseSuccess)

export const getApproveContinueRebiddingUrl = () => {


  

  return `https://etp.it4prof.ru/api/admin/order/continue-rebidding`
}

export const approveContinueRebidding = async (orderContinueRebiddingApproveDTO: OrderContinueRebiddingApproveDTO, options?: RequestInit): Promise<approveContinueRebiddingResponse> => {
  
  return customFetch<approveContinueRebiddingResponse>(getApproveContinueRebiddingUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      orderContinueRebiddingApproveDTO,)
  }
);}




export const getApproveContinueRebiddingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveContinueRebidding>>, TError,{data: OrderContinueRebiddingApproveDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveContinueRebidding>>, TError,{data: OrderContinueRebiddingApproveDTO}, TContext> => {

const mutationKey = ['approveContinueRebidding'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveContinueRebidding>>, {data: OrderContinueRebiddingApproveDTO}> = (props) => {
          const {data} = props ?? {};

          return  approveContinueRebidding(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ApproveContinueRebiddingMutationResult = NonNullable<Awaited<ReturnType<typeof approveContinueRebidding>>>
    export type ApproveContinueRebiddingMutationBody = OrderContinueRebiddingApproveDTO
    export type ApproveContinueRebiddingMutationError = unknown

    /**
 * @summary Одобрение/отклонение запроса на продление торгов
 */
export const useApproveContinueRebidding = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveContinueRebidding>>, TError,{data: OrderContinueRebiddingApproveDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveContinueRebidding>>,
        TError,
        {data: OrderContinueRebiddingApproveDTO},
        TContext
      > => {

      const mutationOptions = getApproveContinueRebiddingMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Подтверждение/возврат заявки на модерации
 */
export type acceptOrderResponse200 = {
  data: AcceptOrder200
  status: 200
}
    
export type acceptOrderResponseSuccess = (acceptOrderResponse200) & {
  headers: Headers;
};
;

export type acceptOrderResponse = (acceptOrderResponseSuccess)

export const getAcceptOrderUrl = () => {


  

  return `https://etp.it4prof.ru/api/admin/order/accept`
}

export const acceptOrder = async (acceptOrderDTO: AcceptOrderDTO, options?: RequestInit): Promise<acceptOrderResponse> => {
  
  return customFetch<acceptOrderResponse>(getAcceptOrderUrl(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      acceptOrderDTO,)
  }
);}




export const getAcceptOrderMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptOrder>>, TError,{data: AcceptOrderDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptOrder>>, TError,{data: AcceptOrderDTO}, TContext> => {

const mutationKey = ['acceptOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptOrder>>, {data: AcceptOrderDTO}> = (props) => {
          const {data} = props ?? {};

          return  acceptOrder(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcceptOrderMutationResult = NonNullable<Awaited<ReturnType<typeof acceptOrder>>>
    export type AcceptOrderMutationBody = AcceptOrderDTO
    export type AcceptOrderMutationError = unknown

    /**
 * @summary Подтверждение/возврат заявки на модерации
 */
export const useAcceptOrder = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptOrder>>, TError,{data: AcceptOrderDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acceptOrder>>,
        TError,
        {data: AcceptOrderDTO},
        TContext
      > => {

      const mutationOptions = getAcceptOrderMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Утверждение/отклонение заявки на отмену 
 */
export type acceptOrder1Response200 = {
  data: AcceptOrder1200
  status: 200
}
    
export type acceptOrder1ResponseSuccess = (acceptOrder1Response200) & {
  headers: Headers;
};
;

export type acceptOrder1Response = (acceptOrder1ResponseSuccess)

export const getAcceptOrder1Url = () => {


  

  return `https://etp.it4prof.ru/api/admin/cargo/order/cancel/accept`
}

export const acceptOrder1 = async (acceptOrderCancelDTO: AcceptOrderCancelDTO, options?: RequestInit): Promise<acceptOrder1Response> => {
  
  return customFetch<acceptOrder1Response>(getAcceptOrder1Url(),
  {      
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      acceptOrderCancelDTO,)
  }
);}




export const getAcceptOrder1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptOrder1>>, TError,{data: AcceptOrderCancelDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof acceptOrder1>>, TError,{data: AcceptOrderCancelDTO}, TContext> => {

const mutationKey = ['acceptOrder1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof acceptOrder1>>, {data: AcceptOrderCancelDTO}> = (props) => {
          const {data} = props ?? {};

          return  acceptOrder1(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AcceptOrder1MutationResult = NonNullable<Awaited<ReturnType<typeof acceptOrder1>>>
    export type AcceptOrder1MutationBody = AcceptOrderCancelDTO
    export type AcceptOrder1MutationError = unknown

    /**
 * @summary Утверждение/отклонение заявки на отмену 
 */
export const useAcceptOrder1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof acceptOrder1>>, TError,{data: AcceptOrderCancelDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof acceptOrder1>>,
        TError,
        {data: AcceptOrderCancelDTO},
        TContext
      > => {

      const mutationOptions = getAcceptOrder1MutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Запрос на рефреш токена
 */
export type authUserResponse200 = {
  data: AuthResponseDTOAuthUserDTO
  status: 200
}
    
export type authUserResponseSuccess = (authUserResponse200) & {
  headers: Headers;
};
;

export type authUserResponse = (authUserResponseSuccess)

export const getAuthUserUrl = () => {


  

  return `https://etp.it4prof.ru/api/user/refresh`
}

export const authUser = async (refreshRequest: RefreshRequest, options?: RequestInit): Promise<authUserResponse> => {
  
  return customFetch<authUserResponse>(getAuthUserUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      refreshRequest,)
  }
);}




export const getAuthUserMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authUser>>, TError,{data: RefreshRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof authUser>>, TError,{data: RefreshRequest}, TContext> => {

const mutationKey = ['authUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authUser>>, {data: RefreshRequest}> = (props) => {
          const {data} = props ?? {};

          return  authUser(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthUserMutationResult = NonNullable<Awaited<ReturnType<typeof authUser>>>
    export type AuthUserMutationBody = RefreshRequest
    export type AuthUserMutationError = unknown

    /**
 * @summary Запрос на рефреш токена
 */
export const useAuthUser = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authUser>>, TError,{data: RefreshRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authUser>>,
        TError,
        {data: RefreshRequest},
        TContext
      > => {

      const mutationOptions = getAuthUserMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Запрос на авторизацию
 */
export type authUser1Response200 = {
  data: AuthResponseDTOAuthUserDTO
  status: 200
}
    
export type authUser1ResponseSuccess = (authUser1Response200) & {
  headers: Headers;
};
;

export type authUser1Response = (authUser1ResponseSuccess)

export const getAuthUser1Url = () => {


  

  return `https://etp.it4prof.ru/api/user/auth`
}

export const authUser1 = async (authRequest: AuthRequest, options?: RequestInit): Promise<authUser1Response> => {
  
  return customFetch<authUser1Response>(getAuthUser1Url(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      authRequest,)
  }
);}




export const getAuthUser1MutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authUser1>>, TError,{data: AuthRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof authUser1>>, TError,{data: AuthRequest}, TContext> => {

const mutationKey = ['authUser1'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof authUser1>>, {data: AuthRequest}> = (props) => {
          const {data} = props ?? {};

          return  authUser1(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type AuthUser1MutationResult = NonNullable<Awaited<ReturnType<typeof authUser1>>>
    export type AuthUser1MutationBody = AuthRequest
    export type AuthUser1MutationError = unknown

    /**
 * @summary Запрос на авторизацию
 */
export const useAuthUser1 = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof authUser1>>, TError,{data: AuthRequest}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof authUser1>>,
        TError,
        {data: AuthRequest},
        TContext
      > => {

      const mutationOptions = getAuthUser1MutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Загрузка справочника «Станции ЖД»
 */
export type uploadRailstationsResponse201 = {
  data: UploadRailstations201
  status: 201
}

export type uploadRailstationsResponse400 = {
  data: UploadRailstations400
  status: 400
}
    
export type uploadRailstationsResponseSuccess = (uploadRailstationsResponse201) & {
  headers: Headers;
};
export type uploadRailstationsResponseError = (uploadRailstationsResponse400) & {
  headers: Headers;
};

export type uploadRailstationsResponse = (uploadRailstationsResponseSuccess | uploadRailstationsResponseError)

export const getUploadRailstationsUrl = () => {


  

  return `https://etp.it4prof.ru/api/catalogs/in/railstations`
}

export const uploadRailstations = async (uploadRailstationsBody: UploadRailstationsBody, options?: RequestInit): Promise<uploadRailstationsResponse> => {
    const formData = new FormData();
formData.append(`file`, uploadRailstationsBody.file)

  return customFetch<uploadRailstationsResponse>(getUploadRailstationsUrl(),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}




export const getUploadRailstationsMutationOptions = <TError = UploadRailstations400,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadRailstations>>, TError,{data: UploadRailstationsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadRailstations>>, TError,{data: UploadRailstationsBody}, TContext> => {

const mutationKey = ['uploadRailstations'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadRailstations>>, {data: UploadRailstationsBody}> = (props) => {
          const {data} = props ?? {};

          return  uploadRailstations(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadRailstationsMutationResult = NonNullable<Awaited<ReturnType<typeof uploadRailstations>>>
    export type UploadRailstationsMutationBody = UploadRailstationsBody
    export type UploadRailstationsMutationError = UploadRailstations400

    /**
 * @summary Загрузка справочника «Станции ЖД»
 */
export const useUploadRailstations = <TError = UploadRailstations400,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadRailstations>>, TError,{data: UploadRailstationsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadRailstations>>,
        TError,
        {data: UploadRailstationsBody},
        TContext
      > => {

      const mutationOptions = getUploadRailstationsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Загрузка справочника «Дороги ЖД»
 */
export type uploadRailroadsResponse201 = {
  data: UploadRailroads201
  status: 201
}

export type uploadRailroadsResponse400 = {
  data: UploadRailroads400
  status: 400
}
    
export type uploadRailroadsResponseSuccess = (uploadRailroadsResponse201) & {
  headers: Headers;
};
export type uploadRailroadsResponseError = (uploadRailroadsResponse400) & {
  headers: Headers;
};

export type uploadRailroadsResponse = (uploadRailroadsResponseSuccess | uploadRailroadsResponseError)

export const getUploadRailroadsUrl = () => {


  

  return `https://etp.it4prof.ru/api/catalogs/in/railroads`
}

export const uploadRailroads = async (uploadRailroadsBody: UploadRailroadsBody, options?: RequestInit): Promise<uploadRailroadsResponse> => {
    const formData = new FormData();
formData.append(`file`, uploadRailroadsBody.file)

  return customFetch<uploadRailroadsResponse>(getUploadRailroadsUrl(),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}




export const getUploadRailroadsMutationOptions = <TError = UploadRailroads400,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadRailroads>>, TError,{data: UploadRailroadsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadRailroads>>, TError,{data: UploadRailroadsBody}, TContext> => {

const mutationKey = ['uploadRailroads'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadRailroads>>, {data: UploadRailroadsBody}> = (props) => {
          const {data} = props ?? {};

          return  uploadRailroads(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadRailroadsMutationResult = NonNullable<Awaited<ReturnType<typeof uploadRailroads>>>
    export type UploadRailroadsMutationBody = UploadRailroadsBody
    export type UploadRailroadsMutationError = UploadRailroads400

    /**
 * @summary Загрузка справочника «Дороги ЖД»
 */
export const useUploadRailroads = <TError = UploadRailroads400,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadRailroads>>, TError,{data: UploadRailroadsBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadRailroads>>,
        TError,
        {data: UploadRailroadsBody},
        TContext
      > => {

      const mutationOptions = getUploadRailroadsMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Загрузка справочника «Модели ПС»
 */
export type uploadRailcoachesResponse201 = {
  data: UploadRailcoaches201
  status: 201
}

export type uploadRailcoachesResponse400 = {
  data: UploadRailcoaches400
  status: 400
}
    
export type uploadRailcoachesResponseSuccess = (uploadRailcoachesResponse201) & {
  headers: Headers;
};
export type uploadRailcoachesResponseError = (uploadRailcoachesResponse400) & {
  headers: Headers;
};

export type uploadRailcoachesResponse = (uploadRailcoachesResponseSuccess | uploadRailcoachesResponseError)

export const getUploadRailcoachesUrl = () => {


  

  return `https://etp.it4prof.ru/api/catalogs/in/railcoaches`
}

export const uploadRailcoaches = async (uploadRailcoachesBody: UploadRailcoachesBody, options?: RequestInit): Promise<uploadRailcoachesResponse> => {
    const formData = new FormData();
formData.append(`file`, uploadRailcoachesBody.file)

  return customFetch<uploadRailcoachesResponse>(getUploadRailcoachesUrl(),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}




export const getUploadRailcoachesMutationOptions = <TError = UploadRailcoaches400,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadRailcoaches>>, TError,{data: UploadRailcoachesBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadRailcoaches>>, TError,{data: UploadRailcoachesBody}, TContext> => {

const mutationKey = ['uploadRailcoaches'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadRailcoaches>>, {data: UploadRailcoachesBody}> = (props) => {
          const {data} = props ?? {};

          return  uploadRailcoaches(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadRailcoachesMutationResult = NonNullable<Awaited<ReturnType<typeof uploadRailcoaches>>>
    export type UploadRailcoachesMutationBody = UploadRailcoachesBody
    export type UploadRailcoachesMutationError = UploadRailcoaches400

    /**
 * @summary Загрузка справочника «Модели ПС»
 */
export const useUploadRailcoaches = <TError = UploadRailcoaches400,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadRailcoaches>>, TError,{data: UploadRailcoachesBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadRailcoaches>>,
        TError,
        {data: UploadRailcoachesBody},
        TContext
      > => {

      const mutationOptions = getUploadRailcoachesMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Загрузка справочника «ЕТСНГ»
 */
export type uploadEtsngResponse201 = {
  data: UploadEtsng201
  status: 201
}

export type uploadEtsngResponse400 = {
  data: UploadEtsng400
  status: 400
}
    
export type uploadEtsngResponseSuccess = (uploadEtsngResponse201) & {
  headers: Headers;
};
export type uploadEtsngResponseError = (uploadEtsngResponse400) & {
  headers: Headers;
};

export type uploadEtsngResponse = (uploadEtsngResponseSuccess | uploadEtsngResponseError)

export const getUploadEtsngUrl = () => {


  

  return `https://etp.it4prof.ru/api/catalogs/in/etsng`
}

export const uploadEtsng = async (uploadEtsngBody: UploadEtsngBody, options?: RequestInit): Promise<uploadEtsngResponse> => {
    const formData = new FormData();
formData.append(`file`, uploadEtsngBody.file)

  return customFetch<uploadEtsngResponse>(getUploadEtsngUrl(),
  {      
    ...options,
    method: 'POST'
    ,
    body: 
      formData,
  }
);}




export const getUploadEtsngMutationOptions = <TError = UploadEtsng400,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadEtsng>>, TError,{data: UploadEtsngBody}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof uploadEtsng>>, TError,{data: UploadEtsngBody}, TContext> => {

const mutationKey = ['uploadEtsng'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof uploadEtsng>>, {data: UploadEtsngBody}> = (props) => {
          const {data} = props ?? {};

          return  uploadEtsng(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UploadEtsngMutationResult = NonNullable<Awaited<ReturnType<typeof uploadEtsng>>>
    export type UploadEtsngMutationBody = UploadEtsngBody
    export type UploadEtsngMutationError = UploadEtsng400

    /**
 * @summary Загрузка справочника «ЕТСНГ»
 */
export const useUploadEtsng = <TError = UploadEtsng400,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof uploadEtsng>>, TError,{data: UploadEtsngBody}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof uploadEtsng>>,
        TError,
        {data: UploadEtsngBody},
        TContext
      > => {

      const mutationOptions = getUploadEtsngMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Запрос модератору на продление торгов
 */
export type continueRebiddingResponse201 = {
  data: TradeResponseDTOObject
  status: 201
}
    
export type continueRebiddingResponseSuccess = (continueRebiddingResponse201) & {
  headers: Headers;
};
;

export type continueRebiddingResponse = (continueRebiddingResponseSuccess)

export const getContinueRebiddingUrl = () => {


  

  return `https://etp.it4prof.ru/api/cargo/order/offer/continue-rebidding`
}

export const continueRebidding = async (orderContinueRebiddingRequestDTO: OrderContinueRebiddingRequestDTO, options?: RequestInit): Promise<continueRebiddingResponse> => {
  
  return customFetch<continueRebiddingResponse>(getContinueRebiddingUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      orderContinueRebiddingRequestDTO,)
  }
);}




export const getContinueRebiddingMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof continueRebidding>>, TError,{data: OrderContinueRebiddingRequestDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof continueRebidding>>, TError,{data: OrderContinueRebiddingRequestDTO}, TContext> => {

const mutationKey = ['continueRebidding'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof continueRebidding>>, {data: OrderContinueRebiddingRequestDTO}> = (props) => {
          const {data} = props ?? {};

          return  continueRebidding(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ContinueRebiddingMutationResult = NonNullable<Awaited<ReturnType<typeof continueRebidding>>>
    export type ContinueRebiddingMutationBody = OrderContinueRebiddingRequestDTO
    export type ContinueRebiddingMutationError = unknown

    /**
 * @summary Запрос модератору на продление торгов
 */
export const useContinueRebidding = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof continueRebidding>>, TError,{data: OrderContinueRebiddingRequestDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof continueRebidding>>,
        TError,
        {data: OrderContinueRebiddingRequestDTO},
        TContext
      > => {

      const mutationOptions = getContinueRebiddingMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Создание заявки на перевозку груза
 */
export type createCargoOrderResponse201 = {
  data: TradeResponseDTOObject
  status: 201
}
    
export type createCargoOrderResponseSuccess = (createCargoOrderResponse201) & {
  headers: Headers;
};
;

export type createCargoOrderResponse = (createCargoOrderResponseSuccess)

export const getCreateCargoOrderUrl = () => {


  

  return `https://etp.it4prof.ru/api/cargo/order/create`
}

export const createCargoOrder = async (orderCreateDto: OrderCreateDto, options?: RequestInit): Promise<createCargoOrderResponse> => {
  
  return customFetch<createCargoOrderResponse>(getCreateCargoOrderUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      orderCreateDto,)
  }
);}




export const getCreateCargoOrderMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCargoOrder>>, TError,{data: OrderCreateDto}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createCargoOrder>>, TError,{data: OrderCreateDto}, TContext> => {

const mutationKey = ['createCargoOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createCargoOrder>>, {data: OrderCreateDto}> = (props) => {
          const {data} = props ?? {};

          return  createCargoOrder(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateCargoOrderMutationResult = NonNullable<Awaited<ReturnType<typeof createCargoOrder>>>
    export type CreateCargoOrderMutationBody = OrderCreateDto
    export type CreateCargoOrderMutationError = unknown

    /**
 * @summary Создание заявки на перевозку груза
 */
export const useCreateCargoOrder = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createCargoOrder>>, TError,{data: OrderCreateDto}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createCargoOrder>>,
        TError,
        {data: OrderCreateDto},
        TContext
      > => {

      const mutationOptions = getCreateCargoOrderMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Создание пользователя
 */
export type createUserResponse200 = {
  data: AuthResponseDTOObject
  status: 200
}
    
export type createUserResponseSuccess = (createUserResponse200) & {
  headers: Headers;
};
;

export type createUserResponse = (createUserResponseSuccess)

export const getCreateUserUrl = () => {


  

  return `https://etp.it4prof.ru/api/admin/user-create`
}

export const createUser = async (createUserDTO: CreateUserDTO, options?: RequestInit): Promise<createUserResponse> => {
  
  return customFetch<createUserResponse>(getCreateUserUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      createUserDTO,)
  }
);}




export const getCreateUserMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: CreateUserDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: CreateUserDTO}, TContext> => {

const mutationKey = ['createUser'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createUser>>, {data: CreateUserDTO}> = (props) => {
          const {data} = props ?? {};

          return  createUser(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateUserMutationResult = NonNullable<Awaited<ReturnType<typeof createUser>>>
    export type CreateUserMutationBody = CreateUserDTO
    export type CreateUserMutationError = unknown

    /**
 * @summary Создание пользователя
 */
export const useCreateUser = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createUser>>, TError,{data: CreateUserDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createUser>>,
        TError,
        {data: CreateUserDTO},
        TContext
      > => {

      const mutationOptions = getCreateUserMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Смена пароля пользователя
 */
export type changeUserPasswordResponse200 = {
  data: ChangeUserPassword200
  status: 200
}
    
export type changeUserPasswordResponseSuccess = (changeUserPasswordResponse200) & {
  headers: Headers;
};
;

export type changeUserPasswordResponse = (changeUserPasswordResponseSuccess)

export const getChangeUserPasswordUrl = () => {


  

  return `https://etp.it4prof.ru/api/admin/user-change-password`
}

export const changeUserPassword = async (passwordChangeDTO: PasswordChangeDTO, options?: RequestInit): Promise<changeUserPasswordResponse> => {
  
  return customFetch<changeUserPasswordResponse>(getChangeUserPasswordUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      passwordChangeDTO,)
  }
);}




export const getChangeUserPasswordMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeUserPassword>>, TError,{data: PasswordChangeDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof changeUserPassword>>, TError,{data: PasswordChangeDTO}, TContext> => {

const mutationKey = ['changeUserPassword'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof changeUserPassword>>, {data: PasswordChangeDTO}> = (props) => {
          const {data} = props ?? {};

          return  changeUserPassword(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type ChangeUserPasswordMutationResult = NonNullable<Awaited<ReturnType<typeof changeUserPassword>>>
    export type ChangeUserPasswordMutationBody = PasswordChangeDTO
    export type ChangeUserPasswordMutationError = unknown

    /**
 * @summary Смена пароля пользователя
 */
export const useChangeUserPassword = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof changeUserPassword>>, TError,{data: PasswordChangeDTO}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof changeUserPassword>>,
        TError,
        {data: PasswordChangeDTO},
        TContext
      > => {

      const mutationOptions = getChangeUserPasswordMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
export type tradeTestResponse200 = {
  data: TradeTmpDto
  status: 200
}
    
export type tradeTestResponseSuccess = (tradeTestResponse200) & {
  headers: Headers;
};
;

export type tradeTestResponse = (tradeTestResponseSuccess)

export const getTradeTestUrl = () => {


  

  return `https://etp.it4prof.ru/tmp/trade-test`
}

export const tradeTest = async ( options?: RequestInit): Promise<tradeTestResponse> => {
  
  return customFetch<tradeTestResponse>(getTradeTestUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getTradeTestQueryKey = () => {
    return [
    `https://etp.it4prof.ru/tmp/trade-test`
    ] as const;
    }

    
export const getTradeTestQueryOptions = <TData = Awaited<ReturnType<typeof tradeTest>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tradeTest>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getTradeTestQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof tradeTest>>> = ({ signal }) => tradeTest({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof tradeTest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type TradeTestQueryResult = NonNullable<Awaited<ReturnType<typeof tradeTest>>>
export type TradeTestQueryError = unknown


export function useTradeTest<TData = Awaited<ReturnType<typeof tradeTest>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof tradeTest>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof tradeTest>>,
          TError,
          Awaited<ReturnType<typeof tradeTest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useTradeTest<TData = Awaited<ReturnType<typeof tradeTest>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tradeTest>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof tradeTest>>,
          TError,
          Awaited<ReturnType<typeof tradeTest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useTradeTest<TData = Awaited<ReturnType<typeof tradeTest>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tradeTest>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useTradeTest<TData = Awaited<ReturnType<typeof tradeTest>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof tradeTest>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getTradeTestQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export type notificationTestResponse200 = {
  data: NotificationTmpDto
  status: 200
}
    
export type notificationTestResponseSuccess = (notificationTestResponse200) & {
  headers: Headers;
};
;

export type notificationTestResponse = (notificationTestResponseSuccess)

export const getNotificationTestUrl = () => {


  

  return `https://etp.it4prof.ru/tmp/notification-test`
}

export const notificationTest = async ( options?: RequestInit): Promise<notificationTestResponse> => {
  
  return customFetch<notificationTestResponse>(getNotificationTestUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getNotificationTestQueryKey = () => {
    return [
    `https://etp.it4prof.ru/tmp/notification-test`
    ] as const;
    }

    
export const getNotificationTestQueryOptions = <TData = Awaited<ReturnType<typeof notificationTest>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationTest>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getNotificationTestQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof notificationTest>>> = ({ signal }) => notificationTest({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof notificationTest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type NotificationTestQueryResult = NonNullable<Awaited<ReturnType<typeof notificationTest>>>
export type NotificationTestQueryError = unknown


export function useNotificationTest<TData = Awaited<ReturnType<typeof notificationTest>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationTest>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationTest>>,
          TError,
          Awaited<ReturnType<typeof notificationTest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useNotificationTest<TData = Awaited<ReturnType<typeof notificationTest>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationTest>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof notificationTest>>,
          TError,
          Awaited<ReturnType<typeof notificationTest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useNotificationTest<TData = Awaited<ReturnType<typeof notificationTest>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationTest>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useNotificationTest<TData = Awaited<ReturnType<typeof notificationTest>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof notificationTest>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getNotificationTestQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export type authTestResponse200 = {
  data: AuthTmpDto
  status: 200
}
    
export type authTestResponseSuccess = (authTestResponse200) & {
  headers: Headers;
};
;

export type authTestResponse = (authTestResponseSuccess)

export const getAuthTestUrl = () => {


  

  return `https://etp.it4prof.ru/tmp/auth-test`
}

export const authTest = async ( options?: RequestInit): Promise<authTestResponse> => {
  
  return customFetch<authTestResponse>(getAuthTestUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getAuthTestQueryKey = () => {
    return [
    `https://etp.it4prof.ru/tmp/auth-test`
    ] as const;
    }

    
export const getAuthTestQueryOptions = <TData = Awaited<ReturnType<typeof authTest>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authTest>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getAuthTestQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof authTest>>> = ({ signal }) => authTest({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof authTest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type AuthTestQueryResult = NonNullable<Awaited<ReturnType<typeof authTest>>>
export type AuthTestQueryError = unknown


export function useAuthTest<TData = Awaited<ReturnType<typeof authTest>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof authTest>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof authTest>>,
          TError,
          Awaited<ReturnType<typeof authTest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useAuthTest<TData = Awaited<ReturnType<typeof authTest>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authTest>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof authTest>>,
          TError,
          Awaited<ReturnType<typeof authTest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useAuthTest<TData = Awaited<ReturnType<typeof authTest>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authTest>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useAuthTest<TData = Awaited<ReturnType<typeof authTest>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof authTest>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getAuthTestQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





export type apiTestResponse200 = {
  data: ApiTest200
  status: 200
}
    
export type apiTestResponseSuccess = (apiTestResponse200) & {
  headers: Headers;
};
;

export type apiTestResponse = (apiTestResponseSuccess)

export const getApiTestUrl = () => {


  

  return `https://etp.it4prof.ru/tmp/api-test`
}

export const apiTest = async ( options?: RequestInit): Promise<apiTestResponse> => {
  
  return customFetch<apiTestResponse>(getApiTestUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getApiTestQueryKey = () => {
    return [
    `https://etp.it4prof.ru/tmp/api-test`
    ] as const;
    }

    
export const getApiTestQueryOptions = <TData = Awaited<ReturnType<typeof apiTest>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTest>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getApiTestQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof apiTest>>> = ({ signal }) => apiTest({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof apiTest>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type ApiTestQueryResult = NonNullable<Awaited<ReturnType<typeof apiTest>>>
export type ApiTestQueryError = unknown


export function useApiTest<TData = Awaited<ReturnType<typeof apiTest>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTest>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTest>>,
          TError,
          Awaited<ReturnType<typeof apiTest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useApiTest<TData = Awaited<ReturnType<typeof apiTest>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTest>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof apiTest>>,
          TError,
          Awaited<ReturnType<typeof apiTest>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useApiTest<TData = Awaited<ReturnType<typeof apiTest>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTest>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useApiTest<TData = Awaited<ReturnType<typeof apiTest>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof apiTest>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getApiTestQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Получение списка заявок с моим участием как СОБ
 */
export type getMyParticipationOrdersResponse200 = {
  data: TradeResponseDTOPageableResponseDTOMyParticipationOrderResponseDTO
  status: 200
}
    
export type getMyParticipationOrdersResponseSuccess = (getMyParticipationOrdersResponse200) & {
  headers: Headers;
};
;

export type getMyParticipationOrdersResponse = (getMyParticipationOrdersResponseSuccess)

export const getGetMyParticipationOrdersUrl = (params: GetMyParticipationOrdersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://etp.it4prof.ru/api/wagon/order/my-participation?${stringifiedParams}` : `https://etp.it4prof.ru/api/wagon/order/my-participation`
}

export const getMyParticipationOrders = async (params: GetMyParticipationOrdersParams, options?: RequestInit): Promise<getMyParticipationOrdersResponse> => {
  
  return customFetch<getMyParticipationOrdersResponse>(getGetMyParticipationOrdersUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetMyParticipationOrdersQueryKey = (params?: GetMyParticipationOrdersParams,) => {
    return [
    `https://etp.it4prof.ru/api/wagon/order/my-participation`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetMyParticipationOrdersQueryOptions = <TData = Awaited<ReturnType<typeof getMyParticipationOrders>>, TError = unknown>(params: GetMyParticipationOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyParticipationOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetMyParticipationOrdersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getMyParticipationOrders>>> = ({ signal }) => getMyParticipationOrders(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getMyParticipationOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetMyParticipationOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof getMyParticipationOrders>>>
export type GetMyParticipationOrdersQueryError = unknown


export function useGetMyParticipationOrders<TData = Awaited<ReturnType<typeof getMyParticipationOrders>>, TError = unknown>(
 params: GetMyParticipationOrdersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyParticipationOrders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyParticipationOrders>>,
          TError,
          Awaited<ReturnType<typeof getMyParticipationOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMyParticipationOrders<TData = Awaited<ReturnType<typeof getMyParticipationOrders>>, TError = unknown>(
 params: GetMyParticipationOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyParticipationOrders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getMyParticipationOrders>>,
          TError,
          Awaited<ReturnType<typeof getMyParticipationOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetMyParticipationOrders<TData = Awaited<ReturnType<typeof getMyParticipationOrders>>, TError = unknown>(
 params: GetMyParticipationOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyParticipationOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Получение списка заявок с моим участием как СОБ
 */

export function useGetMyParticipationOrders<TData = Awaited<ReturnType<typeof getMyParticipationOrders>>, TError = unknown>(
 params: GetMyParticipationOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getMyParticipationOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetMyParticipationOrdersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Получение списка заявок СОБ
 */
export type getCargoOrdersResponse200 = {
  data: TradeResponseDTOPageableResponseDTOOrderPageAllTradeSobResponseDTO
  status: 200
}
    
export type getCargoOrdersResponseSuccess = (getCargoOrdersResponse200) & {
  headers: Headers;
};
;

export type getCargoOrdersResponse = (getCargoOrdersResponseSuccess)

export const getGetCargoOrdersUrl = (params: GetCargoOrdersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://etp.it4prof.ru/api/wagon/order/get-orders?${stringifiedParams}` : `https://etp.it4prof.ru/api/wagon/order/get-orders`
}

export const getCargoOrders = async (params: GetCargoOrdersParams, options?: RequestInit): Promise<getCargoOrdersResponse> => {
  
  return customFetch<getCargoOrdersResponse>(getGetCargoOrdersUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetCargoOrdersQueryKey = (params?: GetCargoOrdersParams,) => {
    return [
    `https://etp.it4prof.ru/api/wagon/order/get-orders`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCargoOrdersQueryOptions = <TData = Awaited<ReturnType<typeof getCargoOrders>>, TError = unknown>(params: GetCargoOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCargoOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCargoOrdersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCargoOrders>>> = ({ signal }) => getCargoOrders(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCargoOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCargoOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof getCargoOrders>>>
export type GetCargoOrdersQueryError = unknown


export function useGetCargoOrders<TData = Awaited<ReturnType<typeof getCargoOrders>>, TError = unknown>(
 params: GetCargoOrdersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCargoOrders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCargoOrders>>,
          TError,
          Awaited<ReturnType<typeof getCargoOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCargoOrders<TData = Awaited<ReturnType<typeof getCargoOrders>>, TError = unknown>(
 params: GetCargoOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCargoOrders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCargoOrders>>,
          TError,
          Awaited<ReturnType<typeof getCargoOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCargoOrders<TData = Awaited<ReturnType<typeof getCargoOrders>>, TError = unknown>(
 params: GetCargoOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCargoOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Получение списка заявок СОБ
 */

export function useGetCargoOrders<TData = Awaited<ReturnType<typeof getCargoOrders>>, TError = unknown>(
 params: GetCargoOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCargoOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCargoOrdersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Получение аггрегированных данных по участию СОБ в заявках
 */
export type getWagonOwnerAggregateDataResponse200 = {
  data: TradeResponseDTOListAggregateResponseDTO
  status: 200
}
    
export type getWagonOwnerAggregateDataResponseSuccess = (getWagonOwnerAggregateDataResponse200) & {
  headers: Headers;
};
;

export type getWagonOwnerAggregateDataResponse = (getWagonOwnerAggregateDataResponseSuccess)

export const getGetWagonOwnerAggregateDataUrl = (params: GetWagonOwnerAggregateDataParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://etp.it4prof.ru/api/wagon/order/aggregate?${stringifiedParams}` : `https://etp.it4prof.ru/api/wagon/order/aggregate`
}

export const getWagonOwnerAggregateData = async (params: GetWagonOwnerAggregateDataParams, options?: RequestInit): Promise<getWagonOwnerAggregateDataResponse> => {
  
  return customFetch<getWagonOwnerAggregateDataResponse>(getGetWagonOwnerAggregateDataUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetWagonOwnerAggregateDataQueryKey = (params?: GetWagonOwnerAggregateDataParams,) => {
    return [
    `https://etp.it4prof.ru/api/wagon/order/aggregate`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetWagonOwnerAggregateDataQueryOptions = <TData = Awaited<ReturnType<typeof getWagonOwnerAggregateData>>, TError = unknown>(params: GetWagonOwnerAggregateDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWagonOwnerAggregateData>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWagonOwnerAggregateDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWagonOwnerAggregateData>>> = ({ signal }) => getWagonOwnerAggregateData(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWagonOwnerAggregateData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetWagonOwnerAggregateDataQueryResult = NonNullable<Awaited<ReturnType<typeof getWagonOwnerAggregateData>>>
export type GetWagonOwnerAggregateDataQueryError = unknown


export function useGetWagonOwnerAggregateData<TData = Awaited<ReturnType<typeof getWagonOwnerAggregateData>>, TError = unknown>(
 params: GetWagonOwnerAggregateDataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWagonOwnerAggregateData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWagonOwnerAggregateData>>,
          TError,
          Awaited<ReturnType<typeof getWagonOwnerAggregateData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWagonOwnerAggregateData<TData = Awaited<ReturnType<typeof getWagonOwnerAggregateData>>, TError = unknown>(
 params: GetWagonOwnerAggregateDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWagonOwnerAggregateData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWagonOwnerAggregateData>>,
          TError,
          Awaited<ReturnType<typeof getWagonOwnerAggregateData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWagonOwnerAggregateData<TData = Awaited<ReturnType<typeof getWagonOwnerAggregateData>>, TError = unknown>(
 params: GetWagonOwnerAggregateDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWagonOwnerAggregateData>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Получение аггрегированных данных по участию СОБ в заявках
 */

export function useGetWagonOwnerAggregateData<TData = Awaited<ReturnType<typeof getWagonOwnerAggregateData>>, TError = unknown>(
 params: GetWagonOwnerAggregateDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWagonOwnerAggregateData>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetWagonOwnerAggregateDataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Получение своего профиля
 */
export type getUserProfileResponse200 = {
  data: AuthResponseDTOUserProfileResponseDTO
  status: 200
}
    
export type getUserProfileResponseSuccess = (getUserProfileResponse200) & {
  headers: Headers;
};
;

export type getUserProfileResponse = (getUserProfileResponseSuccess)

export const getGetUserProfileUrl = (params: GetUserProfileParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://etp.it4prof.ru/api/user/profile?${stringifiedParams}` : `https://etp.it4prof.ru/api/user/profile`
}

export const getUserProfile = async (params: GetUserProfileParams, options?: RequestInit): Promise<getUserProfileResponse> => {
  
  return customFetch<getUserProfileResponse>(getGetUserProfileUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetUserProfileQueryKey = (params?: GetUserProfileParams,) => {
    return [
    `https://etp.it4prof.ru/api/user/profile`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetUserProfileQueryOptions = <TData = Awaited<ReturnType<typeof getUserProfile>>, TError = unknown>(params: GetUserProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserProfileQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserProfile>>> = ({ signal }) => getUserProfile(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetUserProfileQueryResult = NonNullable<Awaited<ReturnType<typeof getUserProfile>>>
export type GetUserProfileQueryError = unknown


export function useGetUserProfile<TData = Awaited<ReturnType<typeof getUserProfile>>, TError = unknown>(
 params: GetUserProfileParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserProfile>>,
          TError,
          Awaited<ReturnType<typeof getUserProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUserProfile<TData = Awaited<ReturnType<typeof getUserProfile>>, TError = unknown>(
 params: GetUserProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserProfile>>,
          TError,
          Awaited<ReturnType<typeof getUserProfile>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUserProfile<TData = Awaited<ReturnType<typeof getUserProfile>>, TError = unknown>(
 params: GetUserProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Получение своего профиля
 */

export function useGetUserProfile<TData = Awaited<ReturnType<typeof getUserProfile>>, TError = unknown>(
 params: GetUserProfileParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserProfile>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetUserProfileQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Получение инф и ррм
 */
export type getUserInfoResponse200 = {
  data: AuthResponseDTOUserInfoDTO
  status: 200
}
    
export type getUserInfoResponseSuccess = (getUserInfoResponse200) & {
  headers: Headers;
};
;

export type getUserInfoResponse = (getUserInfoResponseSuccess)

export const getGetUserInfoUrl = (params: GetUserInfoParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://etp.it4prof.ru/api/user/info?${stringifiedParams}` : `https://etp.it4prof.ru/api/user/info`
}

export const getUserInfo = async (params: GetUserInfoParams, options?: RequestInit): Promise<getUserInfoResponse> => {
  
  return customFetch<getUserInfoResponse>(getGetUserInfoUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetUserInfoQueryKey = (params?: GetUserInfoParams,) => {
    return [
    `https://etp.it4prof.ru/api/user/info`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetUserInfoQueryOptions = <TData = Awaited<ReturnType<typeof getUserInfo>>, TError = unknown>(params: GetUserInfoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserInfo>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserInfoQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserInfo>>> = ({ signal }) => getUserInfo(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserInfo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetUserInfoQueryResult = NonNullable<Awaited<ReturnType<typeof getUserInfo>>>
export type GetUserInfoQueryError = unknown


export function useGetUserInfo<TData = Awaited<ReturnType<typeof getUserInfo>>, TError = unknown>(
 params: GetUserInfoParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserInfo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserInfo>>,
          TError,
          Awaited<ReturnType<typeof getUserInfo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUserInfo<TData = Awaited<ReturnType<typeof getUserInfo>>, TError = unknown>(
 params: GetUserInfoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserInfo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserInfo>>,
          TError,
          Awaited<ReturnType<typeof getUserInfo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUserInfo<TData = Awaited<ReturnType<typeof getUserInfo>>, TError = unknown>(
 params: GetUserInfoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserInfo>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Получение инф и ррм
 */

export function useGetUserInfo<TData = Awaited<ReturnType<typeof getUserInfo>>, TError = unknown>(
 params: GetUserInfoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserInfo>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetUserInfoQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Список всех статусов завки
 */
export type getAllOrderStatusesResponse200 = {
  data: TradeResponseDTOListOrderStatusDTO
  status: 200
}
    
export type getAllOrderStatusesResponseSuccess = (getAllOrderStatusesResponse200) & {
  headers: Headers;
};
;

export type getAllOrderStatusesResponse = (getAllOrderStatusesResponseSuccess)

export const getGetAllOrderStatusesUrl = () => {


  

  return `https://etp.it4prof.ru/api/order-statuses`
}

export const getAllOrderStatuses = async ( options?: RequestInit): Promise<getAllOrderStatusesResponse> => {
  
  return customFetch<getAllOrderStatusesResponse>(getGetAllOrderStatusesUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAllOrderStatusesQueryKey = () => {
    return [
    `https://etp.it4prof.ru/api/order-statuses`
    ] as const;
    }

    
export const getGetAllOrderStatusesQueryOptions = <TData = Awaited<ReturnType<typeof getAllOrderStatuses>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOrderStatuses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllOrderStatusesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllOrderStatuses>>> = ({ signal }) => getAllOrderStatuses({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllOrderStatuses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllOrderStatusesQueryResult = NonNullable<Awaited<ReturnType<typeof getAllOrderStatuses>>>
export type GetAllOrderStatusesQueryError = unknown


export function useGetAllOrderStatuses<TData = Awaited<ReturnType<typeof getAllOrderStatuses>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOrderStatuses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllOrderStatuses>>,
          TError,
          Awaited<ReturnType<typeof getAllOrderStatuses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllOrderStatuses<TData = Awaited<ReturnType<typeof getAllOrderStatuses>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOrderStatuses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllOrderStatuses>>,
          TError,
          Awaited<ReturnType<typeof getAllOrderStatuses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllOrderStatuses<TData = Awaited<ReturnType<typeof getAllOrderStatuses>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOrderStatuses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Список всех статусов завки
 */

export function useGetAllOrderStatuses<TData = Awaited<ReturnType<typeof getAllOrderStatuses>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllOrderStatuses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllOrderStatusesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Список статусов для страниц торги
 */
export type getTradeOrderStatusesResponse200 = {
  data: TradeResponseDTOListOrderStatusDTO
  status: 200
}
    
export type getTradeOrderStatusesResponseSuccess = (getTradeOrderStatusesResponse200) & {
  headers: Headers;
};
;

export type getTradeOrderStatusesResponse = (getTradeOrderStatusesResponseSuccess)

export const getGetTradeOrderStatusesUrl = () => {


  

  return `https://etp.it4prof.ru/api/order-statuses-trade`
}

export const getTradeOrderStatuses = async ( options?: RequestInit): Promise<getTradeOrderStatusesResponse> => {
  
  return customFetch<getTradeOrderStatusesResponse>(getGetTradeOrderStatusesUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetTradeOrderStatusesQueryKey = () => {
    return [
    `https://etp.it4prof.ru/api/order-statuses-trade`
    ] as const;
    }

    
export const getGetTradeOrderStatusesQueryOptions = <TData = Awaited<ReturnType<typeof getTradeOrderStatuses>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradeOrderStatuses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetTradeOrderStatusesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getTradeOrderStatuses>>> = ({ signal }) => getTradeOrderStatuses({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getTradeOrderStatuses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetTradeOrderStatusesQueryResult = NonNullable<Awaited<ReturnType<typeof getTradeOrderStatuses>>>
export type GetTradeOrderStatusesQueryError = unknown


export function useGetTradeOrderStatuses<TData = Awaited<ReturnType<typeof getTradeOrderStatuses>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradeOrderStatuses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTradeOrderStatuses>>,
          TError,
          Awaited<ReturnType<typeof getTradeOrderStatuses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetTradeOrderStatuses<TData = Awaited<ReturnType<typeof getTradeOrderStatuses>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradeOrderStatuses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTradeOrderStatuses>>,
          TError,
          Awaited<ReturnType<typeof getTradeOrderStatuses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetTradeOrderStatuses<TData = Awaited<ReturnType<typeof getTradeOrderStatuses>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradeOrderStatuses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Список статусов для страниц торги
 */

export function useGetTradeOrderStatuses<TData = Awaited<ReturnType<typeof getTradeOrderStatuses>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getTradeOrderStatuses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetTradeOrderStatusesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Получение пагинированного списка уведомлений по userId
 */
export type getNotificationsResponse200 = {
  data: PageableResponseDTONotificationDTO
  status: 200
}
    
export type getNotificationsResponseSuccess = (getNotificationsResponse200) & {
  headers: Headers;
};
;

export type getNotificationsResponse = (getNotificationsResponseSuccess)

export const getGetNotificationsUrl = (params: GetNotificationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://etp.it4prof.ru/api/notification/read?${stringifiedParams}` : `https://etp.it4prof.ru/api/notification/read`
}

export const getNotifications = async (params: GetNotificationsParams, options?: RequestInit): Promise<getNotificationsResponse> => {
  
  return customFetch<getNotificationsResponse>(getGetNotificationsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetNotificationsQueryKey = (params?: GetNotificationsParams,) => {
    return [
    `https://etp.it4prof.ru/api/notification/read`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetNotificationsQueryOptions = <TData = Awaited<ReturnType<typeof getNotifications>>, TError = unknown>(params: GetNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetNotificationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotifications>>> = ({ signal }) => getNotifications(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof getNotifications>>>
export type GetNotificationsQueryError = unknown


export function useGetNotifications<TData = Awaited<ReturnType<typeof getNotifications>>, TError = unknown>(
 params: GetNotificationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotifications>>,
          TError,
          Awaited<ReturnType<typeof getNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNotifications<TData = Awaited<ReturnType<typeof getNotifications>>, TError = unknown>(
 params: GetNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotifications>>,
          TError,
          Awaited<ReturnType<typeof getNotifications>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetNotifications<TData = Awaited<ReturnType<typeof getNotifications>>, TError = unknown>(
 params: GetNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Получение пагинированного списка уведомлений по userId
 */

export function useGetNotifications<TData = Awaited<ReturnType<typeof getNotifications>>, TError = unknown>(
 params: GetNotificationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotifications>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetNotificationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Получение количества непрочитанных уведомлений
 */
export type getUnreadNotificationCountResponse200 = {
  data: number
  status: 200
}
    
export type getUnreadNotificationCountResponseSuccess = (getUnreadNotificationCountResponse200) & {
  headers: Headers;
};
;

export type getUnreadNotificationCountResponse = (getUnreadNotificationCountResponseSuccess)

export const getGetUnreadNotificationCountUrl = (params: GetUnreadNotificationCountParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://etp.it4prof.ru/api/notification/count?${stringifiedParams}` : `https://etp.it4prof.ru/api/notification/count`
}

export const getUnreadNotificationCount = async (params: GetUnreadNotificationCountParams, options?: RequestInit): Promise<getUnreadNotificationCountResponse> => {
  
  return customFetch<getUnreadNotificationCountResponse>(getGetUnreadNotificationCountUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetUnreadNotificationCountQueryKey = (params?: GetUnreadNotificationCountParams,) => {
    return [
    `https://etp.it4prof.ru/api/notification/count`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetUnreadNotificationCountQueryOptions = <TData = Awaited<ReturnType<typeof getUnreadNotificationCount>>, TError = unknown>(params: GetUnreadNotificationCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadNotificationCount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUnreadNotificationCountQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUnreadNotificationCount>>> = ({ signal }) => getUnreadNotificationCount(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUnreadNotificationCount>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetUnreadNotificationCountQueryResult = NonNullable<Awaited<ReturnType<typeof getUnreadNotificationCount>>>
export type GetUnreadNotificationCountQueryError = unknown


export function useGetUnreadNotificationCount<TData = Awaited<ReturnType<typeof getUnreadNotificationCount>>, TError = unknown>(
 params: GetUnreadNotificationCountParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadNotificationCount>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnreadNotificationCount>>,
          TError,
          Awaited<ReturnType<typeof getUnreadNotificationCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUnreadNotificationCount<TData = Awaited<ReturnType<typeof getUnreadNotificationCount>>, TError = unknown>(
 params: GetUnreadNotificationCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadNotificationCount>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUnreadNotificationCount>>,
          TError,
          Awaited<ReturnType<typeof getUnreadNotificationCount>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUnreadNotificationCount<TData = Awaited<ReturnType<typeof getUnreadNotificationCount>>, TError = unknown>(
 params: GetUnreadNotificationCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadNotificationCount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Получение количества непрочитанных уведомлений
 */

export function useGetUnreadNotificationCount<TData = Awaited<ReturnType<typeof getUnreadNotificationCount>>, TError = unknown>(
 params: GetUnreadNotificationCountParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUnreadNotificationCount>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetUnreadNotificationCountQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Поиск полей «Дорога погрузки/выгрузки» «Код дороги» по справочнику «Дороги ЖД»
 */
export type loadRoadResponse200 = {
  data: TradeResponseDTOPageableResponseDTORoadDTO
  status: 200
}
    
export type loadRoadResponseSuccess = (loadRoadResponse200) & {
  headers: Headers;
};
;

export type loadRoadResponse = (loadRoadResponseSuccess)

export const getLoadRoadUrl = (params: LoadRoadParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://etp.it4prof.ru/api/catalogs/roads?${stringifiedParams}` : `https://etp.it4prof.ru/api/catalogs/roads`
}

export const loadRoad = async (params: LoadRoadParams, options?: RequestInit): Promise<loadRoadResponse> => {
  
  return customFetch<loadRoadResponse>(getLoadRoadUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getLoadRoadQueryKey = (params?: LoadRoadParams,) => {
    return [
    `https://etp.it4prof.ru/api/catalogs/roads`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getLoadRoadQueryOptions = <TData = Awaited<ReturnType<typeof loadRoad>>, TError = unknown>(params: LoadRoadParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadRoad>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLoadRoadQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof loadRoad>>> = ({ signal }) => loadRoad(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof loadRoad>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type LoadRoadQueryResult = NonNullable<Awaited<ReturnType<typeof loadRoad>>>
export type LoadRoadQueryError = unknown


export function useLoadRoad<TData = Awaited<ReturnType<typeof loadRoad>>, TError = unknown>(
 params: LoadRoadParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadRoad>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof loadRoad>>,
          TError,
          Awaited<ReturnType<typeof loadRoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useLoadRoad<TData = Awaited<ReturnType<typeof loadRoad>>, TError = unknown>(
 params: LoadRoadParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadRoad>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof loadRoad>>,
          TError,
          Awaited<ReturnType<typeof loadRoad>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useLoadRoad<TData = Awaited<ReturnType<typeof loadRoad>>, TError = unknown>(
 params: LoadRoadParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadRoad>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Поиск полей «Дорога погрузки/выгрузки» «Код дороги» по справочнику «Дороги ЖД»
 */

export function useLoadRoad<TData = Awaited<ReturnType<typeof loadRoad>>, TError = unknown>(
 params: LoadRoadParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadRoad>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getLoadRoadQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Поиск полей «Станция погрузки/выгрузки» «Код станции» справочнику «Станции ЖД»
 */
export type getRailstationsResponse200 = {
  data: TradeResponseDTOPageableResponseDTOStationDTO
  status: 200
}
    
export type getRailstationsResponseSuccess = (getRailstationsResponse200) & {
  headers: Headers;
};
;

export type getRailstationsResponse = (getRailstationsResponseSuccess)

export const getGetRailstationsUrl = (params: GetRailstationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://etp.it4prof.ru/api/catalogs/railstations?${stringifiedParams}` : `https://etp.it4prof.ru/api/catalogs/railstations`
}

export const getRailstations = async (params: GetRailstationsParams, options?: RequestInit): Promise<getRailstationsResponse> => {
  
  return customFetch<getRailstationsResponse>(getGetRailstationsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetRailstationsQueryKey = (params?: GetRailstationsParams,) => {
    return [
    `https://etp.it4prof.ru/api/catalogs/railstations`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetRailstationsQueryOptions = <TData = Awaited<ReturnType<typeof getRailstations>>, TError = unknown>(params: GetRailstationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRailstations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetRailstationsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getRailstations>>> = ({ signal }) => getRailstations(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getRailstations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetRailstationsQueryResult = NonNullable<Awaited<ReturnType<typeof getRailstations>>>
export type GetRailstationsQueryError = unknown


export function useGetRailstations<TData = Awaited<ReturnType<typeof getRailstations>>, TError = unknown>(
 params: GetRailstationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRailstations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRailstations>>,
          TError,
          Awaited<ReturnType<typeof getRailstations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRailstations<TData = Awaited<ReturnType<typeof getRailstations>>, TError = unknown>(
 params: GetRailstationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRailstations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getRailstations>>,
          TError,
          Awaited<ReturnType<typeof getRailstations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetRailstations<TData = Awaited<ReturnType<typeof getRailstations>>, TError = unknown>(
 params: GetRailstationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRailstations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Поиск полей «Станция погрузки/выгрузки» «Код станции» справочнику «Станции ЖД»
 */

export function useGetRailstations<TData = Awaited<ReturnType<typeof getRailstations>>, TError = unknown>(
 params: GetRailstationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getRailstations>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetRailstationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Поиск поля «Модель вагона» справочнику «Модели ПС»
 */
export type loadWagonModelResponse200 = {
  data: TradeResponseDTOPageableResponseDTOWagonDTO
  status: 200
}
    
export type loadWagonModelResponseSuccess = (loadWagonModelResponse200) & {
  headers: Headers;
};
;

export type loadWagonModelResponse = (loadWagonModelResponseSuccess)

export const getLoadWagonModelUrl = (params: LoadWagonModelParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://etp.it4prof.ru/api/catalogs/railcoaches?${stringifiedParams}` : `https://etp.it4prof.ru/api/catalogs/railcoaches`
}

export const loadWagonModel = async (params: LoadWagonModelParams, options?: RequestInit): Promise<loadWagonModelResponse> => {
  
  return customFetch<loadWagonModelResponse>(getLoadWagonModelUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getLoadWagonModelQueryKey = (params?: LoadWagonModelParams,) => {
    return [
    `https://etp.it4prof.ru/api/catalogs/railcoaches`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getLoadWagonModelQueryOptions = <TData = Awaited<ReturnType<typeof loadWagonModel>>, TError = unknown>(params: LoadWagonModelParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadWagonModel>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLoadWagonModelQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof loadWagonModel>>> = ({ signal }) => loadWagonModel(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof loadWagonModel>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type LoadWagonModelQueryResult = NonNullable<Awaited<ReturnType<typeof loadWagonModel>>>
export type LoadWagonModelQueryError = unknown


export function useLoadWagonModel<TData = Awaited<ReturnType<typeof loadWagonModel>>, TError = unknown>(
 params: LoadWagonModelParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadWagonModel>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof loadWagonModel>>,
          TError,
          Awaited<ReturnType<typeof loadWagonModel>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useLoadWagonModel<TData = Awaited<ReturnType<typeof loadWagonModel>>, TError = unknown>(
 params: LoadWagonModelParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadWagonModel>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof loadWagonModel>>,
          TError,
          Awaited<ReturnType<typeof loadWagonModel>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useLoadWagonModel<TData = Awaited<ReturnType<typeof loadWagonModel>>, TError = unknown>(
 params: LoadWagonModelParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadWagonModel>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Поиск поля «Модель вагона» справочнику «Модели ПС»
 */

export function useLoadWagonModel<TData = Awaited<ReturnType<typeof loadWagonModel>>, TError = unknown>(
 params: LoadWagonModelParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadWagonModel>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getLoadWagonModelQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Список уникальных типов вагонов из справочника «Модели ПС»
 */
export type loadWagonTypeResponse200 = {
  data: TradeResponseDTOListString
  status: 200
}
    
export type loadWagonTypeResponseSuccess = (loadWagonTypeResponse200) & {
  headers: Headers;
};
;

export type loadWagonTypeResponse = (loadWagonTypeResponseSuccess)

export const getLoadWagonTypeUrl = () => {


  

  return `https://etp.it4prof.ru/api/catalogs/railcoaches-type`
}

export const loadWagonType = async ( options?: RequestInit): Promise<loadWagonTypeResponse> => {
  
  return customFetch<loadWagonTypeResponse>(getLoadWagonTypeUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getLoadWagonTypeQueryKey = () => {
    return [
    `https://etp.it4prof.ru/api/catalogs/railcoaches-type`
    ] as const;
    }

    
export const getLoadWagonTypeQueryOptions = <TData = Awaited<ReturnType<typeof loadWagonType>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadWagonType>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLoadWagonTypeQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof loadWagonType>>> = ({ signal }) => loadWagonType({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof loadWagonType>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type LoadWagonTypeQueryResult = NonNullable<Awaited<ReturnType<typeof loadWagonType>>>
export type LoadWagonTypeQueryError = unknown


export function useLoadWagonType<TData = Awaited<ReturnType<typeof loadWagonType>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadWagonType>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof loadWagonType>>,
          TError,
          Awaited<ReturnType<typeof loadWagonType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useLoadWagonType<TData = Awaited<ReturnType<typeof loadWagonType>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadWagonType>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof loadWagonType>>,
          TError,
          Awaited<ReturnType<typeof loadWagonType>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useLoadWagonType<TData = Awaited<ReturnType<typeof loadWagonType>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadWagonType>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Список уникальных типов вагонов из справочника «Модели ПС»
 */

export function useLoadWagonType<TData = Awaited<ReturnType<typeof loadWagonType>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadWagonType>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getLoadWagonTypeQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Поиск полей «Наименование груза» «Код ЕТСНГ» по справочнику «ЕТСНГ»
 */
export type loadCargoResponse200 = {
  data: TradeResponseDTOPageableResponseDTOCargoDTO
  status: 200
}
    
export type loadCargoResponseSuccess = (loadCargoResponse200) & {
  headers: Headers;
};
;

export type loadCargoResponse = (loadCargoResponseSuccess)

export const getLoadCargoUrl = (params: LoadCargoParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://etp.it4prof.ru/api/catalogs/etsng?${stringifiedParams}` : `https://etp.it4prof.ru/api/catalogs/etsng`
}

export const loadCargo = async (params: LoadCargoParams, options?: RequestInit): Promise<loadCargoResponse> => {
  
  return customFetch<loadCargoResponse>(getLoadCargoUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getLoadCargoQueryKey = (params?: LoadCargoParams,) => {
    return [
    `https://etp.it4prof.ru/api/catalogs/etsng`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getLoadCargoQueryOptions = <TData = Awaited<ReturnType<typeof loadCargo>>, TError = unknown>(params: LoadCargoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadCargo>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getLoadCargoQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof loadCargo>>> = ({ signal }) => loadCargo(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof loadCargo>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type LoadCargoQueryResult = NonNullable<Awaited<ReturnType<typeof loadCargo>>>
export type LoadCargoQueryError = unknown


export function useLoadCargo<TData = Awaited<ReturnType<typeof loadCargo>>, TError = unknown>(
 params: LoadCargoParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadCargo>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof loadCargo>>,
          TError,
          Awaited<ReturnType<typeof loadCargo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useLoadCargo<TData = Awaited<ReturnType<typeof loadCargo>>, TError = unknown>(
 params: LoadCargoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadCargo>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof loadCargo>>,
          TError,
          Awaited<ReturnType<typeof loadCargo>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useLoadCargo<TData = Awaited<ReturnType<typeof loadCargo>>, TError = unknown>(
 params: LoadCargoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadCargo>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Поиск полей «Наименование груза» «Код ЕТСНГ» по справочнику «ЕТСНГ»
 */

export function useLoadCargo<TData = Awaited<ReturnType<typeof loadCargo>>, TError = unknown>(
 params: LoadCargoParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof loadCargo>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getLoadCargoQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Получение результатов победителей торгов по заявке
 */
export type getWinnersResultResponse200 = {
  data: TradeResponseDTOWinnersResultResponseDTO
  status: 200
}
    
export type getWinnersResultResponseSuccess = (getWinnersResultResponse200) & {
  headers: Headers;
};
;

export type getWinnersResultResponse = (getWinnersResultResponseSuccess)

export const getGetWinnersResultUrl = (params: GetWinnersResultParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://etp.it4prof.ru/api/cargo/order/winners-result?${stringifiedParams}` : `https://etp.it4prof.ru/api/cargo/order/winners-result`
}

export const getWinnersResult = async (params: GetWinnersResultParams, options?: RequestInit): Promise<getWinnersResultResponse> => {
  
  return customFetch<getWinnersResultResponse>(getGetWinnersResultUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetWinnersResultQueryKey = (params?: GetWinnersResultParams,) => {
    return [
    `https://etp.it4prof.ru/api/cargo/order/winners-result`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetWinnersResultQueryOptions = <TData = Awaited<ReturnType<typeof getWinnersResult>>, TError = unknown>(params: GetWinnersResultParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWinnersResult>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetWinnersResultQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getWinnersResult>>> = ({ signal }) => getWinnersResult(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getWinnersResult>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetWinnersResultQueryResult = NonNullable<Awaited<ReturnType<typeof getWinnersResult>>>
export type GetWinnersResultQueryError = unknown


export function useGetWinnersResult<TData = Awaited<ReturnType<typeof getWinnersResult>>, TError = unknown>(
 params: GetWinnersResultParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWinnersResult>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWinnersResult>>,
          TError,
          Awaited<ReturnType<typeof getWinnersResult>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWinnersResult<TData = Awaited<ReturnType<typeof getWinnersResult>>, TError = unknown>(
 params: GetWinnersResultParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWinnersResult>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getWinnersResult>>,
          TError,
          Awaited<ReturnType<typeof getWinnersResult>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetWinnersResult<TData = Awaited<ReturnType<typeof getWinnersResult>>, TError = unknown>(
 params: GetWinnersResultParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWinnersResult>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Получение результатов победителей торгов по заявке
 */

export function useGetWinnersResult<TData = Awaited<ReturnType<typeof getWinnersResult>>, TError = unknown>(
 params: GetWinnersResultParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getWinnersResult>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetWinnersResultQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Получение сводной таблицы по заказу
 */
export type getPivotTableResponse200 = {
  data: TradeResponseDTOObject
  status: 200
}
    
export type getPivotTableResponseSuccess = (getPivotTableResponse200) & {
  headers: Headers;
};
;

export type getPivotTableResponse = (getPivotTableResponseSuccess)

export const getGetPivotTableUrl = (params: GetPivotTableParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://etp.it4prof.ru/api/cargo/order/offer/pivot-table?${stringifiedParams}` : `https://etp.it4prof.ru/api/cargo/order/offer/pivot-table`
}

export const getPivotTable = async (params: GetPivotTableParams, options?: RequestInit): Promise<getPivotTableResponse> => {
  
  return customFetch<getPivotTableResponse>(getGetPivotTableUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetPivotTableQueryKey = (params?: GetPivotTableParams,) => {
    return [
    `https://etp.it4prof.ru/api/cargo/order/offer/pivot-table`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetPivotTableQueryOptions = <TData = Awaited<ReturnType<typeof getPivotTable>>, TError = unknown>(params: GetPivotTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPivotTable>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetPivotTableQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getPivotTable>>> = ({ signal }) => getPivotTable(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getPivotTable>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetPivotTableQueryResult = NonNullable<Awaited<ReturnType<typeof getPivotTable>>>
export type GetPivotTableQueryError = unknown


export function useGetPivotTable<TData = Awaited<ReturnType<typeof getPivotTable>>, TError = unknown>(
 params: GetPivotTableParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPivotTable>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPivotTable>>,
          TError,
          Awaited<ReturnType<typeof getPivotTable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPivotTable<TData = Awaited<ReturnType<typeof getPivotTable>>, TError = unknown>(
 params: GetPivotTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPivotTable>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getPivotTable>>,
          TError,
          Awaited<ReturnType<typeof getPivotTable>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetPivotTable<TData = Awaited<ReturnType<typeof getPivotTable>>, TError = unknown>(
 params: GetPivotTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPivotTable>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Получение сводной таблицы по заказу
 */

export function useGetPivotTable<TData = Awaited<ReturnType<typeof getPivotTable>>, TError = unknown>(
 params: GetPivotTableParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getPivotTable>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetPivotTableQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Получение деталей предложения по заказу
 */
export type getOfferOrderDetailsResponse200 = {
  data: TradeResponseDTOGetOfferOrderDTO
  status: 200
}
    
export type getOfferOrderDetailsResponseSuccess = (getOfferOrderDetailsResponse200) & {
  headers: Headers;
};
;

export type getOfferOrderDetailsResponse = (getOfferOrderDetailsResponseSuccess)

export const getGetOfferOrderDetailsUrl = (params: GetOfferOrderDetailsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://etp.it4prof.ru/api/cargo/order/offer/details?${stringifiedParams}` : `https://etp.it4prof.ru/api/cargo/order/offer/details`
}

export const getOfferOrderDetails = async (params: GetOfferOrderDetailsParams, options?: RequestInit): Promise<getOfferOrderDetailsResponse> => {
  
  return customFetch<getOfferOrderDetailsResponse>(getGetOfferOrderDetailsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetOfferOrderDetailsQueryKey = (params?: GetOfferOrderDetailsParams,) => {
    return [
    `https://etp.it4prof.ru/api/cargo/order/offer/details`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetOfferOrderDetailsQueryOptions = <TData = Awaited<ReturnType<typeof getOfferOrderDetails>>, TError = unknown>(params: GetOfferOrderDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOfferOrderDetails>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOfferOrderDetailsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOfferOrderDetails>>> = ({ signal }) => getOfferOrderDetails(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOfferOrderDetails>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetOfferOrderDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getOfferOrderDetails>>>
export type GetOfferOrderDetailsQueryError = unknown


export function useGetOfferOrderDetails<TData = Awaited<ReturnType<typeof getOfferOrderDetails>>, TError = unknown>(
 params: GetOfferOrderDetailsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOfferOrderDetails>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOfferOrderDetails>>,
          TError,
          Awaited<ReturnType<typeof getOfferOrderDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetOfferOrderDetails<TData = Awaited<ReturnType<typeof getOfferOrderDetails>>, TError = unknown>(
 params: GetOfferOrderDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOfferOrderDetails>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOfferOrderDetails>>,
          TError,
          Awaited<ReturnType<typeof getOfferOrderDetails>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetOfferOrderDetails<TData = Awaited<ReturnType<typeof getOfferOrderDetails>>, TError = unknown>(
 params: GetOfferOrderDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOfferOrderDetails>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Получение деталей предложения по заказу
 */

export function useGetOfferOrderDetails<TData = Awaited<ReturnType<typeof getOfferOrderDetails>>, TError = unknown>(
 params: GetOfferOrderDetailsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOfferOrderDetails>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetOfferOrderDetailsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Получение детальной заявки по идентификатору
 */
export type getCargoOrderResponse200 = {
  data: TradeResponseDTOOrderDetailResponseDTO
  status: 200
}
    
export type getCargoOrderResponseSuccess = (getCargoOrderResponse200) & {
  headers: Headers;
};
;

export type getCargoOrderResponse = (getCargoOrderResponseSuccess)

export const getGetCargoOrderUrl = (params: GetCargoOrderParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://etp.it4prof.ru/api/cargo/order/get-order?${stringifiedParams}` : `https://etp.it4prof.ru/api/cargo/order/get-order`
}

export const getCargoOrder = async (params: GetCargoOrderParams, options?: RequestInit): Promise<getCargoOrderResponse> => {
  
  return customFetch<getCargoOrderResponse>(getGetCargoOrderUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetCargoOrderQueryKey = (params?: GetCargoOrderParams,) => {
    return [
    `https://etp.it4prof.ru/api/cargo/order/get-order`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCargoOrderQueryOptions = <TData = Awaited<ReturnType<typeof getCargoOrder>>, TError = unknown>(params: GetCargoOrderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCargoOrder>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCargoOrderQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCargoOrder>>> = ({ signal }) => getCargoOrder(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCargoOrder>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCargoOrderQueryResult = NonNullable<Awaited<ReturnType<typeof getCargoOrder>>>
export type GetCargoOrderQueryError = unknown


export function useGetCargoOrder<TData = Awaited<ReturnType<typeof getCargoOrder>>, TError = unknown>(
 params: GetCargoOrderParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCargoOrder>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCargoOrder>>,
          TError,
          Awaited<ReturnType<typeof getCargoOrder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCargoOrder<TData = Awaited<ReturnType<typeof getCargoOrder>>, TError = unknown>(
 params: GetCargoOrderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCargoOrder>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCargoOrder>>,
          TError,
          Awaited<ReturnType<typeof getCargoOrder>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCargoOrder<TData = Awaited<ReturnType<typeof getCargoOrder>>, TError = unknown>(
 params: GetCargoOrderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCargoOrder>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Получение детальной заявки по идентификатору
 */

export function useGetCargoOrder<TData = Awaited<ReturnType<typeof getCargoOrder>>, TError = unknown>(
 params: GetCargoOrderParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCargoOrder>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCargoOrderQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Получение списка своих заявок
 */
export type createCargoOrder1Response200 = {
  data: TradeResponseDTOPageableResponseDTOOrderPageResponseDTO
  status: 200
}
    
export type createCargoOrder1ResponseSuccess = (createCargoOrder1Response200) & {
  headers: Headers;
};
;

export type createCargoOrder1Response = (createCargoOrder1ResponseSuccess)

export const getCreateCargoOrder1Url = (params: CreateCargoOrder1Params,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://etp.it4prof.ru/api/cargo/order/get-my?${stringifiedParams}` : `https://etp.it4prof.ru/api/cargo/order/get-my`
}

export const createCargoOrder1 = async (params: CreateCargoOrder1Params, options?: RequestInit): Promise<createCargoOrder1Response> => {
  
  return customFetch<createCargoOrder1Response>(getCreateCargoOrder1Url(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getCreateCargoOrder1QueryKey = (params?: CreateCargoOrder1Params,) => {
    return [
    `https://etp.it4prof.ru/api/cargo/order/get-my`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getCreateCargoOrder1QueryOptions = <TData = Awaited<ReturnType<typeof createCargoOrder1>>, TError = unknown>(params: CreateCargoOrder1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createCargoOrder1>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreateCargoOrder1QueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof createCargoOrder1>>> = ({ signal }) => createCargoOrder1(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof createCargoOrder1>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type CreateCargoOrder1QueryResult = NonNullable<Awaited<ReturnType<typeof createCargoOrder1>>>
export type CreateCargoOrder1QueryError = unknown


export function useCreateCargoOrder1<TData = Awaited<ReturnType<typeof createCargoOrder1>>, TError = unknown>(
 params: CreateCargoOrder1Params, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof createCargoOrder1>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof createCargoOrder1>>,
          TError,
          Awaited<ReturnType<typeof createCargoOrder1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCreateCargoOrder1<TData = Awaited<ReturnType<typeof createCargoOrder1>>, TError = unknown>(
 params: CreateCargoOrder1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createCargoOrder1>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof createCargoOrder1>>,
          TError,
          Awaited<ReturnType<typeof createCargoOrder1>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCreateCargoOrder1<TData = Awaited<ReturnType<typeof createCargoOrder1>>, TError = unknown>(
 params: CreateCargoOrder1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createCargoOrder1>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Получение списка своих заявок
 */

export function useCreateCargoOrder1<TData = Awaited<ReturnType<typeof createCargoOrder1>>, TError = unknown>(
 params: CreateCargoOrder1Params, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof createCargoOrder1>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getCreateCargoOrder1QueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Получение списка черновиков для пользователя
 */
export type getDraftsResponse200 = {
  data: TradeResponseDTOPageableResponseDTODraftShortResponseDTO
  status: 200
}
    
export type getDraftsResponseSuccess = (getDraftsResponse200) & {
  headers: Headers;
};
;

export type getDraftsResponse = (getDraftsResponseSuccess)

export const getGetDraftsUrl = (params: GetDraftsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://etp.it4prof.ru/api/cargo/order/get-my-draft?${stringifiedParams}` : `https://etp.it4prof.ru/api/cargo/order/get-my-draft`
}

export const getDrafts = async (params: GetDraftsParams, options?: RequestInit): Promise<getDraftsResponse> => {
  
  return customFetch<getDraftsResponse>(getGetDraftsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetDraftsQueryKey = (params?: GetDraftsParams,) => {
    return [
    `https://etp.it4prof.ru/api/cargo/order/get-my-draft`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetDraftsQueryOptions = <TData = Awaited<ReturnType<typeof getDrafts>>, TError = unknown>(params: GetDraftsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDrafts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetDraftsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getDrafts>>> = ({ signal }) => getDrafts(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getDrafts>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetDraftsQueryResult = NonNullable<Awaited<ReturnType<typeof getDrafts>>>
export type GetDraftsQueryError = unknown


export function useGetDrafts<TData = Awaited<ReturnType<typeof getDrafts>>, TError = unknown>(
 params: GetDraftsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDrafts>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDrafts>>,
          TError,
          Awaited<ReturnType<typeof getDrafts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDrafts<TData = Awaited<ReturnType<typeof getDrafts>>, TError = unknown>(
 params: GetDraftsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDrafts>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getDrafts>>,
          TError,
          Awaited<ReturnType<typeof getDrafts>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetDrafts<TData = Awaited<ReturnType<typeof getDrafts>>, TError = unknown>(
 params: GetDraftsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDrafts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Получение списка черновиков для пользователя
 */

export function useGetDrafts<TData = Awaited<ReturnType<typeof getDrafts>>, TError = unknown>(
 params: GetDraftsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getDrafts>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetDraftsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Получение списка всех заявок для ГВ
 */
export type getCargoOrdersAllTradeResponse200 = {
  data: TradeResponseDTOPageableResponseDTOOrderPageAllTradeCargoResponseDTO
  status: 200
}
    
export type getCargoOrdersAllTradeResponseSuccess = (getCargoOrdersAllTradeResponse200) & {
  headers: Headers;
};
;

export type getCargoOrdersAllTradeResponse = (getCargoOrdersAllTradeResponseSuccess)

export const getGetCargoOrdersAllTradeUrl = (params: GetCargoOrdersAllTradeParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://etp.it4prof.ru/api/cargo/order/all-trade?${stringifiedParams}` : `https://etp.it4prof.ru/api/cargo/order/all-trade`
}

export const getCargoOrdersAllTrade = async (params: GetCargoOrdersAllTradeParams, options?: RequestInit): Promise<getCargoOrdersAllTradeResponse> => {
  
  return customFetch<getCargoOrdersAllTradeResponse>(getGetCargoOrdersAllTradeUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetCargoOrdersAllTradeQueryKey = (params?: GetCargoOrdersAllTradeParams,) => {
    return [
    `https://etp.it4prof.ru/api/cargo/order/all-trade`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCargoOrdersAllTradeQueryOptions = <TData = Awaited<ReturnType<typeof getCargoOrdersAllTrade>>, TError = unknown>(params: GetCargoOrdersAllTradeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCargoOrdersAllTrade>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCargoOrdersAllTradeQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCargoOrdersAllTrade>>> = ({ signal }) => getCargoOrdersAllTrade(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCargoOrdersAllTrade>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCargoOrdersAllTradeQueryResult = NonNullable<Awaited<ReturnType<typeof getCargoOrdersAllTrade>>>
export type GetCargoOrdersAllTradeQueryError = unknown


export function useGetCargoOrdersAllTrade<TData = Awaited<ReturnType<typeof getCargoOrdersAllTrade>>, TError = unknown>(
 params: GetCargoOrdersAllTradeParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCargoOrdersAllTrade>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCargoOrdersAllTrade>>,
          TError,
          Awaited<ReturnType<typeof getCargoOrdersAllTrade>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCargoOrdersAllTrade<TData = Awaited<ReturnType<typeof getCargoOrdersAllTrade>>, TError = unknown>(
 params: GetCargoOrdersAllTradeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCargoOrdersAllTrade>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCargoOrdersAllTrade>>,
          TError,
          Awaited<ReturnType<typeof getCargoOrdersAllTrade>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCargoOrdersAllTrade<TData = Awaited<ReturnType<typeof getCargoOrdersAllTrade>>, TError = unknown>(
 params: GetCargoOrdersAllTradeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCargoOrdersAllTrade>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Получение списка всех заявок для ГВ
 */

export function useGetCargoOrdersAllTrade<TData = Awaited<ReturnType<typeof getCargoOrdersAllTrade>>, TError = unknown>(
 params: GetCargoOrdersAllTradeParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCargoOrdersAllTrade>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCargoOrdersAllTradeQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Получение аггрегированных данных по кол-ву заявок для пользователя
 */
export type getAggregateDataResponse200 = {
  data: TradeResponseDTOListAggregateResponseDTO
  status: 200
}
    
export type getAggregateDataResponseSuccess = (getAggregateDataResponse200) & {
  headers: Headers;
};
;

export type getAggregateDataResponse = (getAggregateDataResponseSuccess)

export const getGetAggregateDataUrl = (params: GetAggregateDataParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://etp.it4prof.ru/api/cargo/order/aggregate?${stringifiedParams}` : `https://etp.it4prof.ru/api/cargo/order/aggregate`
}

export const getAggregateData = async (params: GetAggregateDataParams, options?: RequestInit): Promise<getAggregateDataResponse> => {
  
  return customFetch<getAggregateDataResponse>(getGetAggregateDataUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAggregateDataQueryKey = (params?: GetAggregateDataParams,) => {
    return [
    `https://etp.it4prof.ru/api/cargo/order/aggregate`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAggregateDataQueryOptions = <TData = Awaited<ReturnType<typeof getAggregateData>>, TError = unknown>(params: GetAggregateDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAggregateData>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAggregateDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAggregateData>>> = ({ signal }) => getAggregateData(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAggregateData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAggregateDataQueryResult = NonNullable<Awaited<ReturnType<typeof getAggregateData>>>
export type GetAggregateDataQueryError = unknown


export function useGetAggregateData<TData = Awaited<ReturnType<typeof getAggregateData>>, TError = unknown>(
 params: GetAggregateDataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAggregateData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAggregateData>>,
          TError,
          Awaited<ReturnType<typeof getAggregateData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAggregateData<TData = Awaited<ReturnType<typeof getAggregateData>>, TError = unknown>(
 params: GetAggregateDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAggregateData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAggregateData>>,
          TError,
          Awaited<ReturnType<typeof getAggregateData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAggregateData<TData = Awaited<ReturnType<typeof getAggregateData>>, TError = unknown>(
 params: GetAggregateDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAggregateData>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Получение аггрегированных данных по кол-ву заявок для пользователя
 */

export function useGetAggregateData<TData = Awaited<ReturnType<typeof getAggregateData>>, TError = unknown>(
 params: GetAggregateDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAggregateData>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAggregateDataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Пагинированный список всех пользователей (не удаленных) с фильтрами по роли/компании/ИНН
 */
export type getUsersResponse200 = {
  data: AuthResponseDTOPageableResponseDTOUserPageItemDTO
  status: 200
}
    
export type getUsersResponseSuccess = (getUsersResponse200) & {
  headers: Headers;
};
;

export type getUsersResponse = (getUsersResponseSuccess)

export const getGetUsersUrl = (params: GetUsersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://etp.it4prof.ru/api/admin/users?${stringifiedParams}` : `https://etp.it4prof.ru/api/admin/users`
}

export const getUsers = async (params: GetUsersParams, options?: RequestInit): Promise<getUsersResponse> => {
  
  return customFetch<getUsersResponse>(getGetUsersUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetUsersQueryKey = (params?: GetUsersParams,) => {
    return [
    `https://etp.it4prof.ru/api/admin/users`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetUsersQueryOptions = <TData = Awaited<ReturnType<typeof getUsers>>, TError = unknown>(params: GetUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUsersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUsers>>> = ({ signal }) => getUsers(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetUsersQueryResult = NonNullable<Awaited<ReturnType<typeof getUsers>>>
export type GetUsersQueryError = unknown


export function useGetUsers<TData = Awaited<ReturnType<typeof getUsers>>, TError = unknown>(
 params: GetUsersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsers>>,
          TError,
          Awaited<ReturnType<typeof getUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUsers<TData = Awaited<ReturnType<typeof getUsers>>, TError = unknown>(
 params: GetUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUsers>>,
          TError,
          Awaited<ReturnType<typeof getUsers>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUsers<TData = Awaited<ReturnType<typeof getUsers>>, TError = unknown>(
 params: GetUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Пагинированный список всех пользователей (не удаленных) с фильтрами по роли/компании/ИНН
 */

export function useGetUsers<TData = Awaited<ReturnType<typeof getUsers>>, TError = unknown>(
 params: GetUsersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUsers>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetUsersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Получение данных пользователя и его компании по идентификатору пользователя
 */
export type getUserDataResponse200 = {
  data: AuthResponseDTOUserDataDTO
  status: 200
}
    
export type getUserDataResponseSuccess = (getUserDataResponse200) & {
  headers: Headers;
};
;

export type getUserDataResponse = (getUserDataResponseSuccess)

export const getGetUserDataUrl = (params: GetUserDataParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://etp.it4prof.ru/api/admin/user-data?${stringifiedParams}` : `https://etp.it4prof.ru/api/admin/user-data`
}

export const getUserData = async (params: GetUserDataParams, options?: RequestInit): Promise<getUserDataResponse> => {
  
  return customFetch<getUserDataResponse>(getGetUserDataUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetUserDataQueryKey = (params?: GetUserDataParams,) => {
    return [
    `https://etp.it4prof.ru/api/admin/user-data`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetUserDataQueryOptions = <TData = Awaited<ReturnType<typeof getUserData>>, TError = unknown>(params: GetUserDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserData>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserDataQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserData>>> = ({ signal }) => getUserData(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserData>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetUserDataQueryResult = NonNullable<Awaited<ReturnType<typeof getUserData>>>
export type GetUserDataQueryError = unknown


export function useGetUserData<TData = Awaited<ReturnType<typeof getUserData>>, TError = unknown>(
 params: GetUserDataParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserData>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserData>>,
          TError,
          Awaited<ReturnType<typeof getUserData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUserData<TData = Awaited<ReturnType<typeof getUserData>>, TError = unknown>(
 params: GetUserDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserData>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserData>>,
          TError,
          Awaited<ReturnType<typeof getUserData>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUserData<TData = Awaited<ReturnType<typeof getUserData>>, TError = unknown>(
 params: GetUserDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserData>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Получение данных пользователя и его компании по идентификатору пользователя
 */

export function useGetUserData<TData = Awaited<ReturnType<typeof getUserData>>, TError = unknown>(
 params: GetUserDataParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserData>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetUserDataQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Агрегированная информация по пользователям (не удаленным)
 */
export type getUserAggregateResponse200 = {
  data: AuthResponseDTOUserAggregateDTO
  status: 200
}
    
export type getUserAggregateResponseSuccess = (getUserAggregateResponse200) & {
  headers: Headers;
};
;

export type getUserAggregateResponse = (getUserAggregateResponseSuccess)

export const getGetUserAggregateUrl = () => {


  

  return `https://etp.it4prof.ru/api/admin/user-aggregate`
}

export const getUserAggregate = async ( options?: RequestInit): Promise<getUserAggregateResponse> => {
  
  return customFetch<getUserAggregateResponse>(getGetUserAggregateUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetUserAggregateQueryKey = () => {
    return [
    `https://etp.it4prof.ru/api/admin/user-aggregate`
    ] as const;
    }

    
export const getGetUserAggregateQueryOptions = <TData = Awaited<ReturnType<typeof getUserAggregate>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAggregate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetUserAggregateQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getUserAggregate>>> = ({ signal }) => getUserAggregate({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getUserAggregate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetUserAggregateQueryResult = NonNullable<Awaited<ReturnType<typeof getUserAggregate>>>
export type GetUserAggregateQueryError = unknown


export function useGetUserAggregate<TData = Awaited<ReturnType<typeof getUserAggregate>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAggregate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserAggregate>>,
          TError,
          Awaited<ReturnType<typeof getUserAggregate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUserAggregate<TData = Awaited<ReturnType<typeof getUserAggregate>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAggregate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getUserAggregate>>,
          TError,
          Awaited<ReturnType<typeof getUserAggregate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetUserAggregate<TData = Awaited<ReturnType<typeof getUserAggregate>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAggregate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Агрегированная информация по пользователям (не удаленным)
 */

export function useGetUserAggregate<TData = Awaited<ReturnType<typeof getUserAggregate>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getUserAggregate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetUserAggregateQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Пагинированный список заявок для администратора
 */
export type getAdminOrdersResponse200 = {
  data: TradeResponseDTOPageableResponseDTOAdminOrderPageResponseDTO
  status: 200
}
    
export type getAdminOrdersResponseSuccess = (getAdminOrdersResponse200) & {
  headers: Headers;
};
;

export type getAdminOrdersResponse = (getAdminOrdersResponseSuccess)

export const getGetAdminOrdersUrl = (params: GetAdminOrdersParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["companyIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://etp.it4prof.ru/api/admin/orders?${stringifiedParams}` : `https://etp.it4prof.ru/api/admin/orders`
}

export const getAdminOrders = async (params: GetAdminOrdersParams, options?: RequestInit): Promise<getAdminOrdersResponse> => {
  
  return customFetch<getAdminOrdersResponse>(getGetAdminOrdersUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminOrdersQueryKey = (params?: GetAdminOrdersParams,) => {
    return [
    `https://etp.it4prof.ru/api/admin/orders`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetAdminOrdersQueryOptions = <TData = Awaited<ReturnType<typeof getAdminOrders>>, TError = unknown>(params: GetAdminOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminOrdersQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminOrders>>> = ({ signal }) => getAdminOrders(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAdminOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminOrders>>>
export type GetAdminOrdersQueryError = unknown


export function useGetAdminOrders<TData = Awaited<ReturnType<typeof getAdminOrders>>, TError = unknown>(
 params: GetAdminOrdersParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminOrders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminOrders>>,
          TError,
          Awaited<ReturnType<typeof getAdminOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAdminOrders<TData = Awaited<ReturnType<typeof getAdminOrders>>, TError = unknown>(
 params: GetAdminOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminOrders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminOrders>>,
          TError,
          Awaited<ReturnType<typeof getAdminOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAdminOrders<TData = Awaited<ReturnType<typeof getAdminOrders>>, TError = unknown>(
 params: GetAdminOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Пагинированный список заявок для администратора
 */

export function useGetAdminOrders<TData = Awaited<ReturnType<typeof getAdminOrders>>, TError = unknown>(
 params: GetAdminOrdersParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAdminOrdersQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Агрегированная информация по статусам заявок
 */
export type getOrdersAggregateResponse200 = {
  data: TradeResponseDTOListAggregateResponseDTO
  status: 200
}
    
export type getOrdersAggregateResponseSuccess = (getOrdersAggregateResponse200) & {
  headers: Headers;
};
;

export type getOrdersAggregateResponse = (getOrdersAggregateResponseSuccess)

export const getGetOrdersAggregateUrl = () => {


  

  return `https://etp.it4prof.ru/api/admin/orders-aggregate`
}

export const getOrdersAggregate = async ( options?: RequestInit): Promise<getOrdersAggregateResponse> => {
  
  return customFetch<getOrdersAggregateResponse>(getGetOrdersAggregateUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetOrdersAggregateQueryKey = () => {
    return [
    `https://etp.it4prof.ru/api/admin/orders-aggregate`
    ] as const;
    }

    
export const getGetOrdersAggregateQueryOptions = <TData = Awaited<ReturnType<typeof getOrdersAggregate>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrdersAggregate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOrdersAggregateQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOrdersAggregate>>> = ({ signal }) => getOrdersAggregate({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOrdersAggregate>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetOrdersAggregateQueryResult = NonNullable<Awaited<ReturnType<typeof getOrdersAggregate>>>
export type GetOrdersAggregateQueryError = unknown


export function useGetOrdersAggregate<TData = Awaited<ReturnType<typeof getOrdersAggregate>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrdersAggregate>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrdersAggregate>>,
          TError,
          Awaited<ReturnType<typeof getOrdersAggregate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetOrdersAggregate<TData = Awaited<ReturnType<typeof getOrdersAggregate>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrdersAggregate>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOrdersAggregate>>,
          TError,
          Awaited<ReturnType<typeof getOrdersAggregate>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetOrdersAggregate<TData = Awaited<ReturnType<typeof getOrdersAggregate>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrdersAggregate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Агрегированная информация по статусам заявок
 */

export function useGetOrdersAggregate<TData = Awaited<ReturnType<typeof getOrdersAggregate>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOrdersAggregate>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetOrdersAggregateQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Список статусов заявок для администратора
 */
export type getAdminOrderStatusesResponse200 = {
  data: TradeResponseDTOListAdminOrderStatusDTO
  status: 200
}
    
export type getAdminOrderStatusesResponseSuccess = (getAdminOrderStatusesResponse200) & {
  headers: Headers;
};
;

export type getAdminOrderStatusesResponse = (getAdminOrderStatusesResponseSuccess)

export const getGetAdminOrderStatusesUrl = () => {


  

  return `https://etp.it4prof.ru/api/admin/order-statuses`
}

export const getAdminOrderStatuses = async ( options?: RequestInit): Promise<getAdminOrderStatusesResponse> => {
  
  return customFetch<getAdminOrderStatusesResponse>(getGetAdminOrderStatusesUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminOrderStatusesQueryKey = () => {
    return [
    `https://etp.it4prof.ru/api/admin/order-statuses`
    ] as const;
    }

    
export const getGetAdminOrderStatusesQueryOptions = <TData = Awaited<ReturnType<typeof getAdminOrderStatuses>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminOrderStatuses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminOrderStatusesQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminOrderStatuses>>> = ({ signal }) => getAdminOrderStatuses({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminOrderStatuses>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAdminOrderStatusesQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminOrderStatuses>>>
export type GetAdminOrderStatusesQueryError = unknown


export function useGetAdminOrderStatuses<TData = Awaited<ReturnType<typeof getAdminOrderStatuses>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminOrderStatuses>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminOrderStatuses>>,
          TError,
          Awaited<ReturnType<typeof getAdminOrderStatuses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAdminOrderStatuses<TData = Awaited<ReturnType<typeof getAdminOrderStatuses>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminOrderStatuses>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminOrderStatuses>>,
          TError,
          Awaited<ReturnType<typeof getAdminOrderStatuses>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAdminOrderStatuses<TData = Awaited<ReturnType<typeof getAdminOrderStatuses>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminOrderStatuses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Список статусов заявок для администратора
 */

export function useGetAdminOrderStatuses<TData = Awaited<ReturnType<typeof getAdminOrderStatuses>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminOrderStatuses>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAdminOrderStatusesQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Получение данных компании по инн
 */
export type getCompanyResponse200 = {
  data: AuthResponseDTOCompanyDto
  status: 200
}

export type getCompanyResponse404 = {
  data: AuthResponseDTOCompanyDto
  status: 404
}
    
export type getCompanyResponseSuccess = (getCompanyResponse200) & {
  headers: Headers;
};
export type getCompanyResponseError = (getCompanyResponse404) & {
  headers: Headers;
};

export type getCompanyResponse = (getCompanyResponseSuccess | getCompanyResponseError)

export const getGetCompanyUrl = (params: GetCompanyParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://etp.it4prof.ru/api/admin/company-info?${stringifiedParams}` : `https://etp.it4prof.ru/api/admin/company-info`
}

export const getCompany = async (params: GetCompanyParams, options?: RequestInit): Promise<getCompanyResponse> => {
  
  return customFetch<getCompanyResponse>(getGetCompanyUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetCompanyQueryKey = (params?: GetCompanyParams,) => {
    return [
    `https://etp.it4prof.ru/api/admin/company-info`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetCompanyQueryOptions = <TData = Awaited<ReturnType<typeof getCompany>>, TError = AuthResponseDTOCompanyDto>(params: GetCompanyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCompanyQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCompany>>> = ({ signal }) => getCompany(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCompanyQueryResult = NonNullable<Awaited<ReturnType<typeof getCompany>>>
export type GetCompanyQueryError = AuthResponseDTOCompanyDto


export function useGetCompany<TData = Awaited<ReturnType<typeof getCompany>>, TError = AuthResponseDTOCompanyDto>(
 params: GetCompanyParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompany>>,
          TError,
          Awaited<ReturnType<typeof getCompany>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompany<TData = Awaited<ReturnType<typeof getCompany>>, TError = AuthResponseDTOCompanyDto>(
 params: GetCompanyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCompany>>,
          TError,
          Awaited<ReturnType<typeof getCompany>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCompany<TData = Awaited<ReturnType<typeof getCompany>>, TError = AuthResponseDTOCompanyDto>(
 params: GetCompanyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Получение данных компании по инн
 */

export function useGetCompany<TData = Awaited<ReturnType<typeof getCompany>>, TError = AuthResponseDTOCompanyDto>(
 params: GetCompanyParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCompany>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCompanyQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Получение списка заявок в статусе ON_MODERATION
 */
export type getOnModerationOrdersResponse200 = {
  data: TradeResponseDTOListOnModerationOrderDto
  status: 200
}
    
export type getOnModerationOrdersResponseSuccess = (getOnModerationOrdersResponse200) & {
  headers: Headers;
};
;

export type getOnModerationOrdersResponse = (getOnModerationOrdersResponseSuccess)

export const getGetOnModerationOrdersUrl = () => {


  

  return `https://etp.it4prof.ru/api/admin/cargo/order/on-moderation`
}

export const getOnModerationOrders = async ( options?: RequestInit): Promise<getOnModerationOrdersResponse> => {
  
  return customFetch<getOnModerationOrdersResponse>(getGetOnModerationOrdersUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetOnModerationOrdersQueryKey = () => {
    return [
    `https://etp.it4prof.ru/api/admin/cargo/order/on-moderation`
    ] as const;
    }

    
export const getGetOnModerationOrdersQueryOptions = <TData = Awaited<ReturnType<typeof getOnModerationOrders>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnModerationOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetOnModerationOrdersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getOnModerationOrders>>> = ({ signal }) => getOnModerationOrders({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getOnModerationOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetOnModerationOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof getOnModerationOrders>>>
export type GetOnModerationOrdersQueryError = unknown


export function useGetOnModerationOrders<TData = Awaited<ReturnType<typeof getOnModerationOrders>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnModerationOrders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOnModerationOrders>>,
          TError,
          Awaited<ReturnType<typeof getOnModerationOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetOnModerationOrders<TData = Awaited<ReturnType<typeof getOnModerationOrders>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnModerationOrders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getOnModerationOrders>>,
          TError,
          Awaited<ReturnType<typeof getOnModerationOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetOnModerationOrders<TData = Awaited<ReturnType<typeof getOnModerationOrders>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnModerationOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Получение списка заявок в статусе ON_MODERATION
 */

export function useGetOnModerationOrders<TData = Awaited<ReturnType<typeof getOnModerationOrders>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getOnModerationOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetOnModerationOrdersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Список заявок на отмену для модерации
 */
export type getCancelOrdersResponse200 = {
  data: TradeResponseDTOListOrderCancelResponseDTO
  status: 200
}
    
export type getCancelOrdersResponseSuccess = (getCancelOrdersResponse200) & {
  headers: Headers;
};
;

export type getCancelOrdersResponse = (getCancelOrdersResponseSuccess)

export const getGetCancelOrdersUrl = () => {


  

  return `https://etp.it4prof.ru/api/admin/cargo/order/cancel`
}

export const getCancelOrders = async ( options?: RequestInit): Promise<getCancelOrdersResponse> => {
  
  return customFetch<getCancelOrdersResponse>(getGetCancelOrdersUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetCancelOrdersQueryKey = () => {
    return [
    `https://etp.it4prof.ru/api/admin/cargo/order/cancel`
    ] as const;
    }

    
export const getGetCancelOrdersQueryOptions = <TData = Awaited<ReturnType<typeof getCancelOrders>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCancelOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetCancelOrdersQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getCancelOrders>>> = ({ signal }) => getCancelOrders({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getCancelOrders>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetCancelOrdersQueryResult = NonNullable<Awaited<ReturnType<typeof getCancelOrders>>>
export type GetCancelOrdersQueryError = unknown


export function useGetCancelOrders<TData = Awaited<ReturnType<typeof getCancelOrders>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCancelOrders>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCancelOrders>>,
          TError,
          Awaited<ReturnType<typeof getCancelOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCancelOrders<TData = Awaited<ReturnType<typeof getCancelOrders>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCancelOrders>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCancelOrders>>,
          TError,
          Awaited<ReturnType<typeof getCancelOrders>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetCancelOrders<TData = Awaited<ReturnType<typeof getCancelOrders>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCancelOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Список заявок на отмену для модерации
 */

export function useGetCancelOrders<TData = Awaited<ReturnType<typeof getCancelOrders>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getCancelOrders>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetCancelOrdersQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}





/**
 * @summary Удаление заявки по идентификатору
 */
export type deleteCargoOrderResponse200 = {
  data: TradeResponseDTOObject
  status: 200
}
    
export type deleteCargoOrderResponseSuccess = (deleteCargoOrderResponse200) & {
  headers: Headers;
};
;

export type deleteCargoOrderResponse = (deleteCargoOrderResponseSuccess)

export const getDeleteCargoOrderUrl = (params: DeleteCargoOrderParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `https://etp.it4prof.ru/api/cargo/order/delete?${stringifiedParams}` : `https://etp.it4prof.ru/api/cargo/order/delete`
}

export const deleteCargoOrder = async (params: DeleteCargoOrderParams, options?: RequestInit): Promise<deleteCargoOrderResponse> => {
  
  return customFetch<deleteCargoOrderResponse>(getDeleteCargoOrderUrl(params),
  {      
    ...options,
    method: 'DELETE'
    
    
  }
);}




export const getDeleteCargoOrderMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCargoOrder>>, TError,{params: DeleteCargoOrderParams}, TContext>, request?: SecondParameter<typeof customFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteCargoOrder>>, TError,{params: DeleteCargoOrderParams}, TContext> => {

const mutationKey = ['deleteCargoOrder'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteCargoOrder>>, {params: DeleteCargoOrderParams}> = (props) => {
          const {params} = props ?? {};

          return  deleteCargoOrder(params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteCargoOrderMutationResult = NonNullable<Awaited<ReturnType<typeof deleteCargoOrder>>>
    
    export type DeleteCargoOrderMutationError = unknown

    /**
 * @summary Удаление заявки по идентификатору
 */
export const useDeleteCargoOrder = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteCargoOrder>>, TError,{params: DeleteCargoOrderParams}, TContext>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteCargoOrder>>,
        TError,
        {params: DeleteCargoOrderParams},
        TContext
      > => {

      const mutationOptions = getDeleteCargoOrderMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    
/**
 * @summary Компании-инициаторы заявок, доступных администратору
 */
export type getAdminOrderInitiatorsResponse200 = {
  data: TradeResponseDTOListOrderInitiatorDTO
  status: 200
}
    
export type getAdminOrderInitiatorsResponseSuccess = (getAdminOrderInitiatorsResponse200) & {
  headers: Headers;
};
;

export type getAdminOrderInitiatorsResponse = (getAdminOrderInitiatorsResponseSuccess)

export const getGetAdminOrderInitiatorsUrl = () => {


  

  return `https://etp.it4prof.ru/api/admin/order-initiators`
}

export const getAdminOrderInitiators = async ( options?: RequestInit): Promise<getAdminOrderInitiatorsResponse> => {
  
  return customFetch<getAdminOrderInitiatorsResponse>(getGetAdminOrderInitiatorsUrl(),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getGetAdminOrderInitiatorsQueryKey = () => {
    return [
    `https://etp.it4prof.ru/api/admin/order-initiators`
    ] as const;
    }

    
export const getGetAdminOrderInitiatorsQueryOptions = <TData = Awaited<ReturnType<typeof getAdminOrderInitiators>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminOrderInitiators>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAdminOrderInitiatorsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAdminOrderInitiators>>> = ({ signal }) => getAdminOrderInitiators({ signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAdminOrderInitiators>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAdminOrderInitiatorsQueryResult = NonNullable<Awaited<ReturnType<typeof getAdminOrderInitiators>>>
export type GetAdminOrderInitiatorsQueryError = unknown


export function useGetAdminOrderInitiators<TData = Awaited<ReturnType<typeof getAdminOrderInitiators>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminOrderInitiators>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminOrderInitiators>>,
          TError,
          Awaited<ReturnType<typeof getAdminOrderInitiators>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAdminOrderInitiators<TData = Awaited<ReturnType<typeof getAdminOrderInitiators>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminOrderInitiators>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAdminOrderInitiators>>,
          TError,
          Awaited<ReturnType<typeof getAdminOrderInitiators>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAdminOrderInitiators<TData = Awaited<ReturnType<typeof getAdminOrderInitiators>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminOrderInitiators>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Компании-инициаторы заявок, доступных администратору
 */

export function useGetAdminOrderInitiators<TData = Awaited<ReturnType<typeof getAdminOrderInitiators>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAdminOrderInitiators>>, TError, TData>>, request?: SecondParameter<typeof customFetch>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAdminOrderInitiatorsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}
